import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";


const API_BASE = "https://panel.haymestasarim.com/api";
const API_MENU = "https://panel.haymestasarim.com/api/public/menu";
const API_ILETISIM = "https://panel.haymestasarim.com/api/iletisim/public";
const API_ORDERS = "https://panel.haymestasarim.com/api/public/qr-orders";
const IMAGE_BASE = "/menu/images";
const QR_THEME_STYLES = {
  standard:{name:"Standart",icon:"☕",primary:"#ff8a00",dark:"#0b1d2d",bg:"#f4f6f8",card:"#ffffff",text:"#0b1d2d"},
  luxury_gold:{name:"Luxury Gold",icon:"👑",primary:"#d4af37",dark:"#111111",bg:"#f7f2e8",card:"#ffffff",text:"#111111"},
  coffee:{name:"Coffee House",icon:"☕",primary:"#8B5E3C",dark:"#2b1b12",bg:"#f5efe8",card:"#ffffff",text:"#2b1b12"},
  modern_dark:{name:"Modern Dark",icon:"🌙",primary:"#38bdf8",dark:"#020617",bg:"#0f172a",card:"#111827",text:"#ffffff"},
  nature:{name:"Nature Green",icon:"🌿",primary:"#22c55e",dark:"#14532d",bg:"#f0fdf4",card:"#ffffff",text:"#14532d"},

  pizza:{name:"Pizza Italy",icon:"🍕",primary:"#ef4444",dark:"#14532d",bg:"#fff7ed",card:"#ffffff",text:"#1f2937"},
  burger:{name:"Burger Red",icon:"🍔",primary:"#dc2626",dark:"#3b1d0f",bg:"#fff7ed",card:"#ffffff",text:"#3b1d0f"},
  steak:{name:"Steak Premium",icon:"🥩",primary:"#b91c1c",dark:"#1c0f0a",bg:"#fff1f2",card:"#ffffff",text:"#1c0f0a"},
  sushi:{name:"Sushi Black",icon:"🍣",primary:"#f43f5e",dark:"#111827",bg:"#f8fafc",card:"#ffffff",text:"#111827"},
  bakery:{name:"Bakery Cream",icon:"🥐",primary:"#d97706",dark:"#78350f",bg:"#fffbeb",card:"#ffffff",text:"#78350f"},

  icecream:{name:"Ice Cream Pink",icon:"🍦",primary:"#f472b6",dark:"#831843",bg:"#fdf2f8",card:"#ffffff",text:"#831843"},
  seafood:{name:"Seafood Blue",icon:"🐟",primary:"#0ea5e9",dark:"#0c4a6e",bg:"#ecfeff",card:"#ffffff",text:"#0c4a6e"},
  turkish:{name:"Turkish Style",icon:"TR",primary:"#dc2626",dark:"#7f1d1d",bg:"#fff1f2",card:"#ffffff",text:"#7f1d1d"},
  fastfood:{name:"Fast Food",icon:"🍟",primary:"#f97316",dark:"#7c2d12",bg:"#fff7ed",card:"#ffffff",text:"#7c2d12"},
  dessert:{name:"Dessert Sweet",icon:"🍰",primary:"#e879f9",dark:"#701a75",bg:"#fdf4ff",card:"#ffffff",text:"#701a75"},

  beauty:{name:"Beauty Rose",icon:"🌸",primary:"#ec4899",dark:"#831843",bg:"#fff1f2",card:"#ffffff",text:"#831843"},
  spa:{name:"Luxury Spa",icon:"💆",primary:"#14b8a6",dark:"#134e4a",bg:"#f0fdfa",card:"#ffffff",text:"#134e4a"},
  clinic:{name:"Clinic White",icon:"⚕️",primary:"#3b82f6",dark:"#1e3a8a",bg:"#eff6ff",card:"#ffffff",text:"#1e3a8a"},
  gold_black:{name:"Gold Black",icon:"🖤",primary:"#facc15",dark:"#0a0a0a",bg:"#111111",card:"#1f1f1f",text:"#ffffff"},
  purple:{name:"Premium Purple",icon:"💜",primary:"#8b5cf6",dark:"#2e1065",bg:"#f5f3ff",card:"#ffffff",text:"#2e1065"},

  corporate:{name:"Corporate Blue",icon:"💼",primary:"#2563eb",dark:"#0f172a",bg:"#eff6ff",card:"#ffffff",text:"#0f172a"},
  orange:{name:"MesYat Orange",icon:"🟠",primary:"#ff8a00",dark:"#0b1d2d",bg:"#fff7ed",card:"#ffffff",text:"#0b1d2d"},
  glass:{name:"Glass Effect",icon:"💎",primary:"#06b6d4",dark:"#164e63",bg:"#ecfeff",card:"#ffffff",text:"#164e63"},
  minimal:{name:"Minimal Gray",icon:"⚪",primary:"#64748b",dark:"#1f2937",bg:"#f8fafc",card:"#ffffff",text:"#1f2937"},
  business:{name:"Dark Business",icon:"🏢",primary:"#60a5fa",dark:"#020617",bg:"#0f172a",card:"#111827",text:"#ffffff"},

  neon:{name:"Neon Style",icon:"✨",primary:"#22d3ee",dark:"#111827",bg:"#0f172a",card:"#111827",text:"#ffffff"},
  cyber:{name:"Cyber",icon:"🤖",primary:"#a3e635",dark:"#1a2e05",bg:"#f7fee7",card:"#ffffff",text:"#1a2e05"},
  gradient:{name:"Gradient",icon:"🌈",primary:"#9333ea",dark:"#1e1b4b",bg:"#faf5ff",card:"#ffffff",text:"#1e1b4b"},
  instagram:{name:"Instagram Style",icon:"📸",primary:"#e1306c",dark:"#833ab4",bg:"#fff1f2",card:"#ffffff",text:"#4c1d95"},
  marble:{name:"Luxury Marble",icon:"🏛️",primary:"#94a3b8",dark:"#334155",bg:"#f8fafc",card:"#ffffff",text:"#334155"},

  ocean:{name:"Ocean",icon:"🌊",primary:"#0284c7",dark:"#075985",bg:"#e0f2fe",card:"#ffffff",text:"#075985"},
  forest:{name:"Forest",icon:"🌲",primary:"#16a34a",dark:"#14532d",bg:"#f0fdf4",card:"#ffffff",text:"#14532d"},
  vintage:{name:"Vintage",icon:"📻",primary:"#a16207",dark:"#422006",bg:"#fef3c7",card:"#ffffff",text:"#422006"},
  royal:{name:"Royal",icon:"👑",primary:"#7c3aed",dark:"#312e81",bg:"#eef2ff",card:"#ffffff",text:"#312e81"},
  wood:{name:"Wood Cafe",icon:"🪵",primary:"#92400e",dark:"#431407",bg:"#fffbeb",card:"#ffffff",text:"#431407"},

  classic:{name:"Classic",icon:"⭐",primary:"#6b7280",dark:"#111827",bg:"#f9fafb",card:"#ffffff",text:"#111827"},
  premium:{name:"Premium",icon:"💎",primary:"#7c3aed",dark:"#1e1b4b",bg:"#f5f3ff",card:"#ffffff",text:"#1e1b4b"},
  summer:{name:"Summer",icon:"☀️",primary:"#f59e0b",dark:"#7c2d12",bg:"#fff7ed",card:"#ffffff",text:"#7c2d12"},
  night:{name:"Night Mode",icon:"🌃",primary:"#818cf8",dark:"#020617",bg:"#111827",card:"#1f2937",text:"#ffffff"},
  custom:{name:"Custom Brand",icon:"🎨",primary:"#0ea5e9",dark:"#0f172a",bg:"#f0f9ff",card:"#ffffff",text:"#0f172a"}
};

/* 🌍 Tarayıcı dili */
const MENU_LANGS = ["tr", "en", "de", "ar", "fa", "ru", "sq", "es", "pt"];

function detectLang() {
  const l = navigator.language?.slice(0, 2);
  return MENU_LANGS.includes(l) ? l : "tr";
}

/* 🔁 Flutter birebir fallback */
function resolveLang(obj, field, lang) {
  return (
    obj?.[`${field}_${lang}`] ||
    obj?.[`${field}_tr`] ||
    obj?.[`${field}_en`] ||
    obj?.[`${field}_de`] ||
    obj?.[`${field}_ar`] ||
    obj?.[`${field}_fa`] ||
    obj?.[`${field}_ru`] ||
    obj?.[`${field}_sq`] ||
    obj?.[`${field}_es`] ||
    obj?.[`${field}_pt`] ||
    obj?.[field] ||
    ""
  );
}

/* slug */
function slugify(text) {
  return text
    .toLowerCase()
    .replaceAll("&", "ve")
    .replaceAll("ı", "i")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ş", "s")
    .replaceAll("ö", "o")
    .replaceAll("ç", "c")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}

/* kategori resmi */
function resolveCategoryImage(category, section) {
  // 1) İşletmenin panelden seçtiği özel ana kategori resmi varsa önce onu göster
  const uploadedImage =
    section?.image ||
    section?.resim_url ||
    section?.gorsel ||
    section?.category_image ||
    category?.image ||
    category?.resim_url ||
    category?.gorsel ||
    category?.category_image ||
    "";

  if (String(uploadedImage).trim() !== "") {
    return uploadedImage;
  }

  // 2) İşletme özel resim seçmediyse sistemdeki hazır/default kategori resmi gelsin
  if (section?.category_key) {
    return `${IMAGE_BASE}/${section.category_key}.jpg`;
  }

  if (category?.category_key) {
    return `${IMAGE_BASE}/${category.category_key}.jpg`;
  }

  // 3) Hiçbiri yoksa genel default
  return `${IMAGE_BASE}/default.jpg`;
}

/* 🔗 Mini sosyal ikon */
/* mini sosyal icon (YENİ – GERÇEK SVG) */
function MiniIcon({ href, type }) {
  const icons = {
    instagram: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5a5 5 0 100 10 5 5 0 000-10zm6.5-.9a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z"/>
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M23 12s0-4-1-6a3 3 0 00-2-2c-2-.5-8-.5-8-.5s-6 0-8 .5a3 3 0 00-2 2c-1 2-1 6-1 6s0 4 1 6a3 3 0 002 2c2 .5 8 .5 8 .5s6 0 8-.5a3 3 0 002-2c1-2 1-6 1-6zM10 15V9l5 3-5 3z"/>
      </svg>
    ),
    facebook: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M22 12a10 10 0 10-11.5 9.9v-7H8v-3h2.5V9.5c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.7-1.6 1.5V12H16l-.4 3h-2.3v7A10 10 0 0022 12z"/>
      </svg>
    ),
    web: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.9 9h-3a15 15 0 00-1.5-5A8 8 0 0119.9 11zM12 4c.9 1.2 1.7 3 2.1 5H9.9c.4-2 1.2-3.8 2.1-5zM4.1 13h3a15 15 0 001.5 5A8 8 0 014.1 13zm3-2h-3a8 8 0 014.4-5 15 15 0 00-1.4 5zm4.9 9c-.9-1.2-1.7-3-2.1-5h4.2c-.4 2-1.2 3.8-2.1 5zm3.5-2a15 15 0 001.5-5h3a8 8 0 01-4.5 5z"/>
      </svg>
    )
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: 38,
        height: 38,
        borderRadius: "50%",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 14px rgba(0,0,0,.25)"
      }}
    >
      {icons[type]}
    </a>
  );
}



/* metinler */

/* metinler */
const TEXT = {

welcome: {
tr:"Hoş geldiniz",
en:"Welcome",
de:"Willkommen",
ar:"مرحبا بكم",
fa:"خوش آمدید",
ru:"Добро пожаловать",
sq:"Mirë se vini",
es:"Bienvenido",
pt:"Bem-vindo"
},

search:{
tr:"Lezzet arayın…",
en:"Search for flavors…",
de:"Nach Geschmack suchen…",
ar:"ابحث عن النكهات…",
fa:"جستجوی طعم‌ها…",
ru:"Поиск блюд…",
sq:"Kërko shije…",
es:"Buscar sabores…",
pt:"Pesquisar sabores…"
},

trends:{
tr:"Trend Ürünlerimiz",
en:"Featured Items",
de:"Trendprodukte",
ar:"المنتجات المميزة",
fa:"محصولات ویژه",
ru:"Популярные товары",
sq:"Produktet e veçuara",
es:"Productos destacados",
pt:"Produtos em destaque"
},

categories:{
tr:"Kategoriler",
en:"Categories",
de:"Kategorien",
ar:"الفئات",
fa:"دسته‌بندی‌ها",
ru:"Категории",
sq:"Kategoritë",
es:"Categorías",
pt:"Categorias"
},

categoriesSub:{
tr:"Tüm lezzetlerimizi keşfedin",
en:"Explore all our selections",
de:"Entdecken Sie unsere Auswahl",
ar:"اكتشف جميع اختياراتنا",
fa:"همه انتخاب‌های ما را کشف کنید",
ru:"Откройте для себя наш ассортимент",
sq:"Zbuloni zgjedhjet tona",
es:"Descubra nuestra selección",
pt:"Descubra nossa seleção"
},

thanks:{
tr:"Bizi tercih ettiğiniz için teşekkür ederiz",
en:"Thank you for choosing us",
de:"Vielen Dank, dass Sie sich für uns entschieden haben",
ar:"شكرا لاختياركم لنا",
fa:"از انتخاب شما سپاسگزاریم",
ru:"Спасибо, что выбрали нас",
sq:"Faleminderit që na zgjodhët",
es:"Gracias por elegirnos",
pt:"Obrigado por nos escolher"
},

  // ✅ EKLENDI: Sipariş metinleri
  // ✅ PROFESYONEL ÇOK DİLLİ SİPARİŞ / GARSON METİNLERİ
   addToCart: {
    tr: "Sepete Ekle",
    en: "Add to Cart",
    de: "In den Warenkorb",
    ar: "أضف إلى السلة",
    fa: "افزودن به سبد",
    ru: "В корзину",
    sq: "Shto në shportë",
    es: "Añadir al carrito",
    pt: "Adicionar ao carrinho"
  },

  cartAddedTitle: {
    tr: "Sepete eklendi",
    en: "Added to cart",
    de: "Zum Warenkorb hinzugefügt",
    ar: "تمت الإضافة إلى السلة",
    fa: "به سبد خرید اضافه شد",
    ru: "Добавлено в корзину",
    sq: "U shtua në shportë",
    es: "Añadido al carrito",
    pt: "Adicionado ao carrinho"
  },

  cartAddedText: {
    tr: "Ürün başarıyla sepetinize eklendi.",
    en: "The item has been added to your cart.",
    de: "Das Produkt wurde Ihrem Warenkorb hinzugefügt.",
    ar: "تمت إضافة المنتج إلى سلتك بنجاح.",
    fa: "محصول با موفقیت به سبد خرید شما اضافه شد.",
    ru: "Товар успешно добавлен в корзину.",
    sq: "Produkti u shtua me sukses në shportë.",
    es: "El producto se agregó correctamente al carrito.",
    pt: "O produto foi adicionado ao carrinho com sucesso."
  },

  cart: {
    tr: "Sepetim",
    en: "My Cart",
    de: "Mein Warenkorb",
    ar: "سلتي",
    fa: "سبد خرید من",
    ru: "Моя корзина",
    sq: "Shporta ime",
    es: "Mi carrito",
    pt: "Meu carrinho"
  },

  total: {
    tr: "Toplam",
    en: "Total",
    de: "Gesamt",
    ar: "المجموع",
    fa: "مجموع",
    ru: "Итого",
    sq: "Totali",
    es: "Total",
    pt: "Total"
  },

  orderNow: {
    tr: "Sipariş Ver",
    en: "Place Order",
    de: "Bestellen",
    ar: "إرسال الطلب",
    fa: "ثبت سفارش",
    ru: "Оформить заказ",
    sq: "Bëj porosinë",
    es: "Realizar pedido",
    pt: "Fazer pedido"
  },

  customerName: {
    tr: "Adınız",
    en: "Your Name",
    de: "Ihr Name",
    ar: "اسمك",
    fa: "نام شما",
    ru: "Ваше имя",
    sq: "Emri juaj",
    es: "Su nombre",
    pt: "Seu nome"
  },

  tableNo: {
    tr: "Masa No (opsiyonel)",
    en: "Table No (optional)",
    de: "Tischnummer (optional)",
    ar: "رقم الطاولة (اختياري)",
    fa: "شماره میز (اختیاری)",
    ru: "Номер стола (необязательно)",
    sq: "Numri i tavolinës (opsional)",
    es: "Mesa Nº (opcional)",
    pt: "Nº da mesa (opcional)"
  },

  orderNote: {
    tr: "Sipariş Notu (isteğe bağlı)",
    en: "Order Note (optional)",
    de: "Bestellnotiz (optional)",
    ar: "ملاحظة الطلب (اختياري)",
    fa: "یادداشت سفارش (اختیاری)",
    ru: "Примечание к заказу",
    sq: "Shënim porosie",
    es: "Nota del pedido",
    pt: "Observação do pedido"
  },

  emptyCart: {
    tr: "Sepetiniz boş",
    en: "Your cart is empty",
    de: "Ihr Warenkorb ist leer",
    ar: "سلتك فارغة",
    fa: "سبد خرید شما خالی است",
    ru: "Ваша корзина пуста",
    sq: "Shporta është bosh",
    es: "Tu carrito está vacío",
    pt: "Seu carrinho está vazio"
  },

  waiterTitle: {
    tr: "Garson Çağır",
    en: "Call Waiter",
    de: "Kellner rufen",
    ar: "استدعاء النادل",
    fa: "فراخوانی گارسون",
    ru: "Позвать официанта",
    sq: "Thirr kamerierin",
    es: "Llamar al camarero",
    pt: "Chamar garçom"
  },

  cancel: {
    tr: "Vazgeç",
    en: "Cancel",
    de: "Abbrechen",
    ar: "إلغاء",
    fa: "لغو",
    ru: "Отмена",
    sq: "Anulo",
    es: "Cancelar",
    pt: "Cancelar"
  },

  call: {
    tr: "Çağır",
    en: "Call",
    de: "Rufen",
    ar: "استدعاء",
    fa: "فراخوان",
    ru: "Позвать",
    sq: "Thirr",
    es: "Llamar",
    pt: "Chamar"
  },

  missingInfoTitle: {
    tr: "Bilgi eksik",
    en: "Missing information",
    de: "Angaben fehlen",
    ar: "المعلومات ناقصة",
    fa: "اطلاعات ناقص است",
    ru: "Недостаточно данных",
    sq: "Mungon informacioni",
    es: "Falta información",
    pt: "Faltam informações"
  },

  missingWaiterText: {
    tr: "Lütfen masa numarası veya adınızı yazın.",
    en: "Please enter your table number or name.",
    de: "Bitte geben Sie Ihre Tischnummer oder Ihren Namen ein.",
    ar: "يرجى إدخال رقم الطاولة أو اسمك.",
    fa: "لطفاً شماره میز یا نام خود را وارد کنید.",
    ru: "Введите номер стола или ваше имя.",
    sq: "Ju lutemi shkruani numrin e tavolinës ose emrin tuaj.",
    es: "Por favor, escriba el número de mesa o su nombre.",
    pt: "Digite o número da mesa ou seu nome."
  },

  waiterSuccessTitle: {
    tr: "Garson yönlendirildi",
    en: "Waiter is on the way",
    de: "Kellner wurde informiert",
    ar: "النادل في الطريق",
    fa: "گارسون در راه است",
    ru: "Официант уже идет",
    sq: "Kamerieri po vjen",
    es: "El camarero está en camino",
    pt: "O garçom está a caminho"
  },

  waiterSuccessText: {
    tr: "Ekibimiz birazdan masanıza yardımcı olacak.",
    en: "Our team will assist your table shortly.",
    de: "Unser Team ist gleich an Ihrem Tisch.",
    ar: "سيصل فريقنا إلى طاولتك بعد قليل.",
    fa: "تیم ما به‌زودی به میز شما کمک خواهد کرد.",
    ru: "Наша команда скоро подойдет к вашему столу.",
    sq: "Ekipi ynë do t’ju ndihmojë së shpejti.",
    es: "Nuestro equipo le atenderá en breve.",
    pt: "Nossa equipe irá atendê-lo em breve."
  },

  orderNameMissingText: {
    tr: "Sipariş için lütfen adınızı yazın.",
    en: "Please enter your name for the order.",
    de: "Bitte geben Sie Ihren Namen für die Bestellung ein.",
    ar: "يرجى كتابة اسمك لإتمام الطلب.",
    fa: "برای ثبت سفارش لطفاً نام خود را وارد کنید.",
    ru: "Введите ваше имя для заказа.",
    sq: "Ju lutemi shkruani emrin për porosinë.",
    es: "Escriba su nombre para el pedido.",
    pt: "Digite seu nome para o pedido."
  },

  emptyCartText: {
    tr: "Sipariş vermek için önce sepetinize ürün ekleyin.",
    en: "Please add items to your cart before ordering.",
    de: "Bitte legen Sie zuerst Produkte in den Warenkorb.",
    ar: "يرجى إضافة منتجات إلى السلة أولاً.",
    fa: "ابتدا محصولی به سبد خرید اضافه کنید.",
    ru: "Сначала добавьте товары в корзину.",
    sq: "Së pari shtoni produkte në shportë.",
    es: "Primero agregue productos al carrito.",
    pt: "Adicione produtos ao carrinho primeiro."
  },

  orderSuccessTitle: {
    tr: "Siparişiniz alındı",
    en: "Order received",
    de: "Bestellung eingegangen",
    ar: "تم استلام طلبك",
    fa: "سفارش شما ثبت شد",
    ru: "Заказ принят",
    sq: "Porosia u pranua",
    es: "Pedido recibido",
    pt: "Pedido recebido"
  },

  orderSuccessText: {
    tr: "Teşekkür ederiz. Siparişiniz hazırlanıyor.",
    en: "Thank you. Your order is being prepared.",
    de: "Vielen Dank. Ihre Bestellung wird vorbereitet.",
    ar: "شكراً لك. يتم تحضير طلبك الآن.",
    fa: "متشکریم. سفارش شما در حال آماده‌سازی است.",
    ru: "Спасибо. Ваш заказ готовится.",
    sq: "Faleminderit. Porosia juaj po përgatitet.",
    es: "Gracias. Su pedido se está preparando.",
    pt: "Obrigado. Seu pedido está sendo preparado."
  },

  processErrorTitle: {
    tr: "İşlem tamamlanamadı",
    en: "Action could not be completed",
    de: "Vorgang konnte nicht abgeschlossen werden",
    ar: "تعذر إكمال العملية",
    fa: "عملیات کامل نشد",
    ru: "Не удалось выполнить действие",
    sq: "Veprimi nuk u përfundua",
    es: "No se pudo completar la acción",
    pt: "Não foi possível concluir a ação"
  },

  processErrorText: {
    tr: "Lütfen birkaç saniye sonra tekrar deneyin.",
    en: "Please try again in a few seconds.",
    de: "Bitte versuchen Sie es in einigen Sekunden erneut.",
    ar: "يرجى المحاولة مرة أخرى بعد ثوانٍ قليلة.",
    fa: "لطفاً چند ثانیه بعد دوباره تلاش کنید.",
    ru: "Попробуйте снова через несколько секунд.",
    sq: "Ju lutemi provoni përsëri pas pak sekondash.",
    es: "Inténtelo de nuevo en unos segundos.",
    pt: "Tente novamente em alguns segundos."
  },

  connectionErrorTitle: {
    tr: "Bağlantı sorunu",
    en: "Connection issue",
    de: "Verbindungsproblem",
    ar: "مشكلة في الاتصال",
    fa: "مشکل اتصال",
    ru: "Проблема соединения",
    sq: "Problem lidhjeje",
    es: "Problema de conexión",
    pt: "Problema de conexão"
  },

  connectionErrorText: {
    tr: "İstek gönderilemedi. Lütfen tekrar deneyin.",
    en: "Request could not be sent. Please try again.",
    de: "Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    ar: "تعذر إرسال الطلب. يرجى المحاولة مرة أخرى.",
    fa: "درخواست ارسال نشد. لطفاً دوباره تلاش کنید.",
    ru: "Запрос не отправлен. Попробуйте снова.",
    sq: "Kërkesa nuk u dërgua. Provoni përsëri.",
    es: "No se pudo enviar la solicitud. Inténtelo de nuevo.",
    pt: "Não foi possível enviar. Tente novamente."
  },
};

function t(key, lang) {
  return TEXT[key]?.[lang] || TEXT[key]?.tr || "";
}

/* =========================================================
   ✅ PUBLIC MENÜ - MEVZUATA UYUMLU ÜRÜN BİLGİLERİ
   Kalori, içerik, porsiyon, alerjen ve tahmini kalori notu
========================================================= */

const PUBLIC_COMPLIANCE_TEXT = {
  calories: {
    tr: "Kalori",
    en: "Calories",
    de: "Kalorien",
    ar: "السعرات",
    fa: "کالری",
    ru: "Калории",
    sq: "Kalori",
    es: "Calorías",
    pt: "Calorias",
  },
  estimated: {
    tr: "Tahmini",
    en: "Estimated",
    de: "Geschätzt",
    ar: "تقديري",
    fa: "تخمینی",
    ru: "Оценка",
    sq: "E përafërt",
    es: "Estimado",
    pt: "Estimado",
  },
  portion: {
    tr: "Porsiyon",
    en: "Portion",
    de: "Portion",
    ar: "الحصة",
    fa: "پرس",
    ru: "Порция",
    sq: "Porcioni",
    es: "Porción",
    pt: "Porção",
  },
  ingredients: {
    tr: "İçindekiler",
    en: "Ingredients",
    de: "Zutaten",
    ar: "المكونات",
    fa: "مواد تشکیل‌دهنده",
    ru: "Состав",
    sq: "Përbërësit",
    es: "Ingredientes",
    pt: "Ingredientes",
  },
  allergens: {
    tr: "Alerjenler",
    en: "Allergens",
    de: "Allergene",
    ar: "مسببات الحساسية",
    fa: "آلرژن‌ها",
    ru: "Аллергены",
    sq: "Alergjenët",
    es: "Alérgenos",
    pt: "Alergénios",
  },
  warning: {
    tr: "Uyarı",
    en: "Note",
    de: "Hinweis",
    ar: "تنبيه",
    fa: "هشدار",
    ru: "Примечание",
    sq: "Shënim",
    es: "Aviso",
    pt: "Aviso",
  },
  noOfficialAdvice: {
    tr: "Bilgiler işletme tarafından kontrol edilmelidir.",
    en: "Information should be verified by the business.",
    de: "Die Angaben sollten vom Betrieb geprüft werden.",
    ar: "يجب التحقق من المعلومات من قبل المنشأة.",
    fa: "اطلاعات باید توسط کسب‌وکار بررسی شود.",
    ru: "Информация должна быть проверена заведением.",
    sq: "Informacioni duhet të kontrollohet nga biznesi.",
    es: "La información debe ser verificada por el negocio.",
    pt: "As informações devem ser verificadas pelo estabelecimento.",
  },
};

const PUBLIC_ALLERGEN_LABELS = {
  gluten: {
    tr: "Gluten",
    en: "Gluten",
    de: "Gluten",
  },
  crustaceans: {
    tr: "Kabuklular",
    en: "Crustaceans",
    de: "Krebstiere",
  },
  egg: {
    tr: "Yumurta",
    en: "Egg",
    de: "Ei",
  },
  fish: {
    tr: "Balık",
    en: "Fish",
    de: "Fisch",
  },
  peanut: {
    tr: "Yer fıstığı",
    en: "Peanuts",
    de: "Erdnüsse",
  },
  soy: {
    tr: "Soya",
    en: "Soy",
    de: "Soja",
  },
  milk: {
    tr: "Süt / Laktoz",
    en: "Milk / Lactose",
    de: "Milch / Laktose",
  },
  nuts: {
    tr: "Sert kabuklu yemişler",
    en: "Nuts",
    de: "Schalenfrüchte",
  },
  celery: {
    tr: "Kereviz",
    en: "Celery",
    de: "Sellerie",
  },
  mustard: {
    tr: "Hardal",
    en: "Mustard",
    de: "Senf",
  },
  sesame: {
    tr: "Susam",
    en: "Sesame",
    de: "Sesam",
  },
  sulphites: {
    tr: "Sülfit",
    en: "Sulphites",
    de: "Sulfite",
  },
  lupin: {
    tr: "Acı bakla",
    en: "Lupin",
    de: "Lupine",
  },
  molluscs: {
    tr: "Yumuşakçalar",
    en: "Molluscs",
    de: "Weichtiere",
  },
};

const PUBLIC_DIETARY_LABELS = {
  vegan: {
    tr: "Vegan",
    en: "Vegan",
    de: "Vegan",
  },
  vegetarian: {
    tr: "Vejetaryen",
    en: "Vegetarian",
    de: "Vegetarisch",
  },
  gluten_free: {
    tr: "Glutensiz",
    en: "Gluten-free",
    de: "Glutenfrei",
  },
  lactose_free: {
    tr: "Laktozsuz",
    en: "Lactose-free",
    de: "Laktosefrei",
  },
  contains_alcohol: {
    tr: "Alkol içerir",
    en: "Contains alcohol",
    de: "Enthält Alkohol",
  },
  no_pork: {
    tr: "Domuz türevi içermez",
    en: "No pork-derived ingredients",
    de: "Keine Schweinebestandteile",
  },
};

function ct(key, lang) {
  return (
    PUBLIC_COMPLIANCE_TEXT?.[key]?.[lang] ||
    PUBLIC_COMPLIANCE_TEXT?.[key]?.tr ||
    key
  );
}

function safePublicJsonParse(value, fallback) {
  if (value && typeof value === "object") return value;

  try {
    return JSON.parse(value || JSON.stringify(fallback));
  } catch {
    return fallback;
  }
}

function publicLangValue(obj, lang) {
  return (
    obj?.[lang] ||
    obj?.tr ||
    obj?.en ||
    obj?.de ||
    obj?.ar ||
    obj?.fa ||
    obj?.ru ||
    obj?.sq ||
    obj?.es ||
    obj?.pt ||
    ""
  );
}

function normalizePublicArray(value) {
  const list = Array.isArray(value)
    ? value
    : safePublicJsonParse(value, []);

  if (!Array.isArray(list)) return [];

  return list.map((x) => String(x || "").trim()).filter(Boolean);
}

function normalizePublicComplianceInfo(value) {
  const raw = safePublicJsonParse(value, {});

  return {
    ingredients:
      raw.ingredients && typeof raw.ingredients === "object"
        ? raw.ingredients
        : {},
    portion:
      raw.portion && typeof raw.portion === "object"
        ? raw.portion
        : {},
    warning:
      raw.warning && typeof raw.warning === "object"
        ? raw.warning
        : {},
    calories:
      raw.calories !== undefined && raw.calories !== null
        ? String(raw.calories).trim()
        : "",
    calories_estimated: raw.calories_estimated === true,
    calorie_note:
      raw.calorie_note && typeof raw.calorie_note === "object"
        ? raw.calorie_note
        : {},
    tags: Array.isArray(raw.tags)
      ? raw.tags.map((x) => String(x || "").trim()).filter(Boolean)
      : [],
  };
}

function getPublicAllergenLabels(allergens, lang) {
  return normalizePublicArray(allergens).map((key) => {
    return (
      PUBLIC_ALLERGEN_LABELS?.[key]?.[lang] ||
      PUBLIC_ALLERGEN_LABELS?.[key]?.tr ||
      key
    );
  });
}

function getPublicDietaryLabels(tags, lang) {
  return normalizePublicArray(tags).map((key) => {
    return (
      PUBLIC_DIETARY_LABELS?.[key]?.[lang] ||
      PUBLIC_DIETARY_LABELS?.[key]?.tr ||
      key
    );
  });
}

function hasPublicComplianceInfo(item) {
  const c = normalizePublicComplianceInfo(item?.compliance_info);
  const allergens = getPublicAllergenLabels(item?.allergens, "tr");
  const ingredients = publicLangValue(c.ingredients, "tr");
  const portion = publicLangValue(c.portion, "tr");
  const warning = publicLangValue(c.warning, "tr");

  return Boolean(
    c.calories ||
      ingredients ||
      portion ||
      warning ||
      allergens.length ||
      c.tags.length
  );
}



function PublicComplianceBox({ item, lang, themeStyle, compact = false }) {
  if (!hasPublicComplianceInfo(item)) return null;

  const c = normalizePublicComplianceInfo(item?.compliance_info);
  const calories = c.calories;
  const ingredients = publicLangValue(c.ingredients, lang);
  const portion = publicLangValue(c.portion, lang);
  const warning = publicLangValue(c.warning, lang);
  const allergens = getPublicAllergenLabels(item?.allergens, lang);
  const dietaryTags = getPublicDietaryLabels(c.tags, lang);

  if (compact) {
    const allergyList = [...allergens, ...dietaryTags].slice(0, 3);

    return (
      <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 10, display: "grid", gap: 6 }}>
        {(calories || portion) && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
            {calories && (
              <span style={{ fontSize: 10, fontWeight: 900, color: themeStyle.primary, background: "rgba(255,138,0,.10)", border: "1px solid rgba(255,138,0,.22)", borderRadius: 999, padding: "3px 7px", lineHeight: "13px" }}>
                {calories} kcal
              </span>
            )}

            {portion && (
              <span style={{ fontSize: 10, fontWeight: 850, color: "#475569", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 999, padding: "3px 7px", lineHeight: "13px" }}>
                {portion}
              </span>
            )}
          </div>
        )}

        {allergyList.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
            {allergyList.map((label, index) => (
              <span key={`${label}-${index}`} style={{ fontSize: 9.5, fontWeight: 800, color: "#64748b", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 999, padding: "3px 7px", lineHeight: "12px" }}>
                {label}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 12 }}>
      {(calories || portion) && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginBottom: 10 }}>
          {calories && (
            <span style={{ fontSize: 11, fontWeight: 900, color: themeStyle.primary, background: "rgba(255,138,0,.10)", border: "1px solid rgba(255,138,0,.20)", borderRadius: 999, padding: "5px 9px" }}>
              {calories} kcal
            </span>
          )}
          {portion && (
            <span style={{ fontSize: 11, fontWeight: 850, color: "#334155", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 999, padding: "5px 9px" }}>
              {portion}
            </span>
          )}
        </div>
      )}

      {ingredients && (
        <div style={{ fontSize: 12.5, color: "#475569", lineHeight: "18px", marginBottom: 9 }}>
          <strong style={{ color: "#0f172a" }}>{ct("ingredients", lang)}:</strong> {ingredients}
        </div>
      )}

      {(allergens.length > 0 || dietaryTags.length > 0) && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {[...allergens, ...dietaryTags].slice(0, 8).map((label, index) => (
            <span key={`${label}-${index}`} style={{ fontSize: 10.5, fontWeight: 800, color: "#475569", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 999, padding: "4px 8px" }}>
              {label}
            </span>
          ))}
        </div>
      )}

      {warning && (
        <div style={{ marginTop: 9, fontSize: 11.5, color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: 8, lineHeight: "16px" }}>
          {warning}
        </div>
      )}
    </div>
  );
}






// Eski ürünleri bozmaz. price_options yoksa boş array döner.
function normalizePublicPriceOptions(value) {
  let list = [];

  if (Array.isArray(value)) {
    list = value;
  } else if (typeof value === "string") {
    try {
      list = JSON.parse(value || "[]");
    } catch {
      list = [];
    }
  }

  if (!Array.isArray(list)) return [];

  return list
    .map((opt, index) => ({
      id: opt.id || `opt-${index}`,
      label: String(opt.label || opt.name || opt.title || "").trim(),
      price: Number(opt.price ?? opt.fiyat ?? 0),
      currency: opt.currency || opt.para_birimi || "TRY",
    }))
    .filter((opt) => opt.label && Number(opt.price) > 0);
}

function moneyText(price, currency = "TRY") {
  const n = Number(price || 0);

  return `${n.toLocaleString("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} ${currency || "TRY"}`;
}

function hasPublicPriceOptions(item) {
  return normalizePublicPriceOptions(item?.price_options).length > 1;
}

function getPublicItemPriceText(item) {
  const options = normalizePublicPriceOptions(item?.price_options);

  // ✅ Sadece birden fazla gerçek seçenek varsa "başlayan" yazsın
  if (options.length > 1) {
    const prices = options
      .map((opt) => Number(opt.price || 0))
      .filter((x) => x > 0);

    const min = Math.min(...prices);
    const currency = options[0]?.currency || item?.currency || "TRY";

    return `${moneyText(min, currency)}’den başlayan`;
  }

  return moneyText(item?.price, item?.currency || "TRY");
}

// ✅ Trend alanında seçenekli ürünleri sade gösterir.
// Örnek: 80 TRY - 200 TRY
function getPublicTrendPriceText(item) {
  const options = normalizePublicPriceOptions(item?.price_options);

  if (options.length > 1) {
    const prices = options
      .map((opt) => Number(opt.price || 0))
      .filter((x) => x > 0);

    const min = Math.min(...prices);
    const max = Math.max(...prices);
    const currency = options[0]?.currency || item?.currency || "TRY";

    if (min === max) return moneyText(min, currency);

    return `${moneyText(min, currency)} - ${moneyText(max, currency)}`;
  }

  return moneyText(item?.price, item?.currency || "TRY");
}

/* 🔗 Sosyal ikon */
function SocialIcon({ href, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 16px rgba(0,0,0,.25)",
        fontWeight: 700,
        color: "#0b1d2d",
        textDecoration: "none"
      }}
    >
      {label}
    </a>
  );
}

// ✅ EKLENDI: Basit TextField bileşeni (MUI kullanmamak için)
function TextField({
  label,
  fullWidth,
  margin,
  value,
  onChange,
  type,
  multiline,
  rows,
}) {
  const inputStyle = {
    width: fullWidth ? "100%" : "auto",
    boxSizing: "border-box",
    padding: "12px 13px",
    borderRadius: 14,
    border: "1px solid #dbe3ef",
    fontSize: 15,
    fontWeight: 800,
    color: "#0b1d2d",
    background: "#ffffff",
    outline: "none",
    boxShadow: "inset 0 1px 0 rgba(15,23,42,0.03)",
  };

  return (
    <div
      style={{
        marginBottom: margin === "normal" ? 14 : 0,
        background: "#ffffff",
        borderRadius: 18,
        padding: "10px 10px 11px",
        border: "1px solid #e5eaf2",
        boxShadow: "0 6px 18px rgba(15,23,42,0.06)",
      }}
    >
      <label
        style={{
          display: "block",
          marginBottom: 7,
          fontSize: 12,
          fontWeight: 950,
          color: "#0b1d2d",
          letterSpacing: ".2px",
        }}
      >
        {label}
      </label>

      {multiline ? (
        <textarea
          rows={rows}
          value={value}
          onChange={onChange}
          style={{
            ...inputStyle,
            minHeight: rows ? rows * 28 : 84,
            resize: "vertical",
            lineHeight: "20px",
          }}
        />
      ) : (
        <input
          type={type || "text"}
          value={value}
          onChange={onChange}
          style={inputStyle}
        />
      )}
    </div>
  );
}

function ProductImageBox({
  src,
  alt = "",
  height = 165,
  radiusTop = 0,
  radiusBottom = 0,
}) {
  const imageSrc = src || `${IMAGE_BASE}/default.jpg`;

  return (
    <div
      className="menu-product-img"
      style={{
        height,
        position: "relative",
        overflow: "hidden",
        borderTopLeftRadius: radiusTop,
        borderTopRightRadius: radiusTop,
        borderBottomLeftRadius: radiusBottom,
        borderBottomRightRadius: radiusBottom,
        background:
          "radial-gradient(circle at 20% 15%, rgba(255,159,28,.18), transparent 32%), linear-gradient(135deg, #ffffff 0%, #eef2f7 100%)",
        padding: 12,
        boxSizing: "border-box",
        borderBottom: "1px solid #eef0f3",
      }}
    >
      <div
        className="menu-photo-frame"
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 22,
          overflow: "hidden",
          background: "#fff",
          boxShadow:
            "0 12px 26px rgba(15,23,42,.16), inset 0 0 0 1px rgba(255,255,255,.65)",
          position: "relative",
        }}
      >
        <img
          src={imageSrc}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
           objectFit: "cover",
objectPosition: "center center",
            objectPosition: "center",
            display: "block",
          }}
          onError={(e) => {
            e.currentTarget.src = `${IMAGE_BASE}/default.jpg`;
          }}
        />

        <div
          className="menu-photo-shine"
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(120deg, transparent 0%, rgba(255,255,255,.35) 45%, transparent 70%)",
            transform: "translateX(-120%)",
            pointerEvents: "none",
          }}
        />
      </div>
    </div>
  );
}
export default function PublicMenu() {
  const { kurumId } = useParams();

  const [lang, setLang] = useState(detectLang());
  const [menuLangs, setMenuLangs] = useState([]);
  const [sections, setSections] = useState([]);
const [contact, setContact] = useState({});
const [googleReview, setGoogleReview] = useState(null);
const [loading, setLoading] = useState(true);
const [loadingBusinessName, setLoadingBusinessName] = useState("");
const loadingStartRef = useRef(Date.now());
const loadingTimerRef = useRef(null);
const [menuOptions, setMenuOptions] = useState({
  garson_cagir_active: true,
  siparis_active: true,
  theme_default: "standard",
  theme_options: [
    "standard",
    "luxury_gold",
    "coffee",
    "modern_dark",
    "nature"
  ]
});

  const [openSection, setOpenSection] = useState(null);
  const [openItem, setOpenItem] = useState(null);

const [search, setSearch] = useState("");
const [showThemePanel, setShowThemePanel] = useState(false);
const [activeTheme, setActiveTheme] = useState("standard");
const themeStyle =
  QR_THEME_STYLES[activeTheme] || QR_THEME_STYLES.standard;

const isDarkTheme = [
  "modern_dark",
  "gold_black",
  "business",
  "neon",
  "night"
].includes(activeTheme);

const pageBackground = isDarkTheme
  ? `radial-gradient(circle at top, ${themeStyle.primary}26, transparent 32%),
     linear-gradient(180deg, ${themeStyle.dark} 0%, #020617 46%, #0f172a 100%)`
  : `radial-gradient(circle at top, ${themeStyle.primary}26, transparent 30%),
     linear-gradient(180deg, ${themeStyle.dark} 0%, #071421 42%, #111827 100%)`;

const sectionTitleColor = "#ffffff";
const sectionSubColor = "rgba(255,255,255,0.70)";

const softPanelBg = "rgba(255,255,255,0.08)";
const softPanelBorder = "rgba(255,255,255,0.13)";
const softCardBg = "rgba(255,255,255,0.96)";

  /* ⭐ trend modal */
  const [activeItem, setActiveItem] = useState(null);

   /* slider */
  const sliderRef = useRef(null);
  const autoRef = useRef(null);

  // ✅ Ana sayfaya / en üste dönmek için
  const menuTopRef = useRef(null);

  // ✅ Kategoriye basınca o kategori ekranın üstüne gelsin
  const categoryRefs = useRef({});

  // ✅ EKLENDI: Sepet state ve sipariş formu state'leri
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [tableNo, setTableNo] = useState("");
  const [orderNote, setOrderNote] = useState("");
  
  // ✅ GARSON ÇAĞIRMA MODAL STATELERİ
   const [showWaiterModal, setShowWaiterModal] = useState(false);
  const [waiterMasaNo, setWaiterMasaNo] = useState("");
  const [waiterAd, setWaiterAd] = useState("");

  // ✅ Profesyonel garson bildirimi
  // ✅ Tüm sistem için profesyonel çok dilli bildirim
  const [appNotice, setAppNotice] = useState(null);
  const noticeTimerRef = useRef(null);
  // ✅ GARSON ÇAĞIRMA FONKSİYONU


const showAppNotice = (
  type,
  titleKey,
  textKey,
  position = "bottom",
  icon = null
) => {
  if (noticeTimerRef.current) {
    clearTimeout(noticeTimerRef.current);
  }

  setAppNotice({
    type,
    title: t(titleKey, lang),
    text: t(textKey, lang),
    position,
    icon
  });

  noticeTimerRef.current = setTimeout(() => {
    setAppNotice(null);
  }, position === "center" ? 1800 : 3600);
};

const callWaiter = async () => {
  if (!waiterMasaNo.trim() && !waiterAd.trim()) {
    showAppNotice("warning", "missingInfoTitle", "missingWaiterText");
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/public/qr-orders/call-waiter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kurum_id: kurumId,
        masa_no: waiterMasaNo || "Belirtilmemiş",
        musteri_adi: waiterAd || "Misafir",
        telefon: ""
      })
    });

    if (res.ok) {
      setShowWaiterModal(false);
      setWaiterMasaNo("");
      setWaiterAd("");

      showAppNotice(
        "success",
        "waiterSuccessTitle",
        "waiterSuccessText",
        "center",
        "🔔"
      );

    } else {
      showAppNotice("error", "processErrorTitle", "processErrorText");
    }
  } catch (err) {
    console.error("Garson çağırma hatası:", err);
    showAppNotice("error", "connectionErrorTitle", "connectionErrorText");
  }
};


  // ✅ EKLENDI: Sepet işlemleri
const addToCart = (item, option = null) => {
  const selectedOption = option
    ? {
        id: option.id,
        label: option.label,
        price: Number(option.price || 0),
        currency: option.currency || item.currency || "TRY",
      }
    : null;

  const cartId = selectedOption
    ? `${item.id}-${selectedOption.id}`
    : String(item.id);

  const cartItem = {
    ...item,
    id: cartId,
    product_id: item.id,
    title: selectedOption
      ? `${item.title} - ${selectedOption.label}`
      : item.title,
    price: selectedOption
      ? selectedOption.price
      : Number(item.price || 0),
    currency: selectedOption
      ? selectedOption.currency
      : item.currency || "TRY",
    selected_option: selectedOption,
  };

  setCart(prev => {
    const existing = prev.find(i => i.id === cartId);

    if (existing) {
      return prev.map(i =>
        i.id === cartId
          ? { ...i, quantity: i.quantity + 1 }
          : i
      );
    }

    return [...prev, { ...cartItem, quantity: 1 }];
  });

  showAppNotice(
    "success",
    "cartAddedTitle",
    "cartAddedText",
    "center",
    "✓"
  );
};


  const removeFromCart = (itemId) => {
    setCart(prev => prev.filter(i => i.id !== itemId));
  };

  const updateQuantity = (itemId, newQty) => {
    if (newQty <= 0) {
      removeFromCart(itemId);
      return;
    }
    setCart(prev => prev.map(i => i.id === itemId ? { ...i, quantity: newQty } : i));
  };

  const cartTotal = useMemo(() => {
    return cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }, [cart]);

// ✅ EKLENDI: Sipariş gönderme
const submitOrder = async () => {
  if (!customerName.trim()) {
    showAppNotice("warning", "missingInfoTitle", "orderNameMissingText");
    return;
  }

  if (cart.length === 0) {
    showAppNotice("warning", "emptyCart", "emptyCartText");
    return;
  }

  const orderData = {
    kurum_id: kurumId,
    musteri_adi: customerName,
    telefon: "",
    masa_no: tableNo || null,
    siparis_notu: orderNote || null,
 items: cart.map(item => ({
  id: item.product_id || item.id,
  title: item.title,
  price: item.price,
  currency: item.currency || "TRY",
  quantity: item.quantity
})),
    toplam_tutar: cartTotal,
    durum: "yeni"
  };

  try {
    const res = await fetch(API_ORDERS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(orderData)
    });

    if (!res.ok) throw new Error("Sunucu hatası");

    const result = await res.json();

    console.log("Sipariş oluştu:", result);

    showAppNotice("success", "orderSuccessTitle", "orderSuccessText");
    // Sepeti ve formu sıfırla
    setCart([]);
    setCustomerName("");
    setTableNo("");
    setOrderNote("");
    setShowCart(false);

    // Profesyonel bildirim showAppNotice ile gösteriliyor


  } catch (err) {
    console.error("Sipariş hatası:", err);

    showAppNotice("error", "processErrorTitle", "processErrorText");


    // Profesyonel bildirim showAppNotice ile gösteriliyor

  }
};


useEffect(() => {
  return () => {
    if (noticeTimerRef.current) {
      clearTimeout(noticeTimerRef.current);
    }

    if (loadingTimerRef.current) {
      clearTimeout(loadingTimerRef.current);
    }
  };
}, []);

  useEffect(() => {
    if (!kurumId) return;

    setLoading(true);
    loadingStartRef.current = Date.now();

    if (loadingTimerRef.current) {
      clearTimeout(loadingTimerRef.current);
    }

fetch(`${API_MENU}?kurum_id=${kurumId}&lang=${lang}`)
  .then(r => r.json())
  .then(async (menuRes) => {
const realKurumId =
  menuRes.kurum_id ||
  menuRes.kurumId ||
  menuRes.id ||
  menuRes.data?.kurum_id ||
  menuRes.data?.kurumId ||
  menuRes.data?.id ||
  menuRes.kurum?.id ||
  menuRes.business?.id ||
  kurumId;

console.log("MENU RES:", menuRes);
console.log("REAL KURUM ID:", realKurumId);

 const iletisimRes = await fetch(
  `${API_ILETISIM}?kurum_id=${realKurumId}&lang=tr`
).then(r => r.json());

        const allowed = menuRes.menu_langs?.length ? menuRes.menu_langs : ["tr"];
        setMenuLangs(allowed);

        if (!allowed.includes(lang)) {
          setLang(allowed[0]);
          return;
        }

const contactData = iletisimRes.data || {};

setContact(contactData);
setLoadingBusinessName(
  contactData.kurum_adi ||
  contactData.business_name ||
  contactData.title ||
  menuRes.kurum_adi ||
  menuRes.business_name ||
  "QR Menü"
);

setGoogleReview(menuRes.google_review || null);

const defaultTheme = menuRes.theme_default || "standard";
const themeOptions = Array.isArray(menuRes.theme_options)
  ? menuRes.theme_options
  : [
      "standard",
      "luxury_gold",
      "coffee",
      "modern_dark",
      "nature"
    ];

setMenuOptions({
  garson_cagir_active:
    menuRes.garson_cagir_active !== false,

  siparis_active:
    menuRes.siparis_active !== false,

  theme_default: defaultTheme,
  theme_options: themeOptions
});

setActiveTheme(defaultTheme);


        const cleaned = (menuRes.sections || []).map(sec => ({
          ...sec,
          title: resolveLang(sec, "title", lang),
          categories: sec.categories.map(cat => ({
            ...cat,
            title: resolveLang(cat, "title", lang),
         items: cat.items.map(item => ({
  ...item,
  title: resolveLang(item, "title", lang),
  description: resolveLang(item, "description", lang),
  price_options: normalizePublicPriceOptions(item.price_options),
}))
          }))
        }));

        setSections(cleaned);

        const minLoadingTime = 2200; // 2.2 saniye ekranda kalsın
        const elapsed = Date.now() - loadingStartRef.current;
        const remaining = Math.max(0, minLoadingTime - elapsed);

        loadingTimerRef.current = setTimeout(() => {
          setLoading(false);
        }, remaining);

      });
  }, [kurumId, lang]);

  /* ⭐ TREND */
  const trendItems = useMemo(
    () =>
      sections
        .flatMap(s => s.categories)
        .flatMap(c => c.items)
        .filter(i => i.is_trend),
    [sections]
  );

  /* 🔍 ARAMA */
  const filteredSections = useMemo(() => {
    if (!search) return sections;
    const q = search.toLowerCase();
    return sections
      .map(sec => ({
        ...sec,
        categories: sec.categories.map(cat => ({
          ...cat,
          items: cat.items.filter(
            i =>
              i.title.toLowerCase().includes(q) ||
              i.description?.toLowerCase().includes(q)
          )
        }))
      }))
      .filter(sec => sec.categories.some(c => c.items.length));
  }, [sections, search]);

  /* ▶️ auto slider */
useEffect(() => {
  if (!trendItems.length || !sliderRef.current) return;

  const slider = sliderRef.current;
  let direction = 1;

  autoRef.current = setInterval(() => {
    // sona geldiyse başa dön
    if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5) {
      slider.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }

    slider.scrollBy({
      left: 260,
      behavior: "smooth"
    });
  }, 2500);

  return () => clearInterval(autoRef.current);
}, [trendItems]);



  /* body scroll lock (PWA uyum) */
  useEffect(() => {
    document.body.style.overflow = activeItem ? "hidden" : "auto";
  }, [activeItem]);

   if (loading) {
    const displayName =
      loadingBusinessName ||
      contact?.kurum_adi ||
      "QR Menü";

    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          background:
            "radial-gradient(circle at top, rgba(255,138,0,.28), transparent 34%), linear-gradient(180deg, #071421 0%, #0b1d2d 48%, #071421 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          boxSizing: "border-box",
          color: "#fff",
          overflow: "hidden",
          position: "relative"
        }}
      >
        <style>{`
          @keyframes qrLoaderFloat {
            0%, 100% {
              transform: translateY(0) scale(1);
            }
            50% {
              transform: translateY(-8px) scale(1.03);
            }
          }

          @keyframes qrLoaderSpin {
            to {
              transform: rotate(360deg);
            }
          }

 
          @keyframes qrLoaderPulse {
            0%, 100% {
              opacity: .35;
              transform: scale(.94);
            }
            50% {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes qrLoaderBar {
            0% {
              transform: translateX(-110%);
            }
            100% {
              transform: translateX(110%);
            }
          }

          .qr-loader-card {
            animation: qrLoaderFloat 2.2s ease-in-out infinite;
          }

          .qr-loader-ring {
            animation: qrLoaderSpin 1.4s linear infinite;
          }

          .qr-loader-dot {
            animation: qrLoaderPulse 1.2s ease-in-out infinite;
          }

          .qr-loader-dot:nth-child(2) {
            animation-delay: .15s;
          }

          .qr-loader-dot:nth-child(3) {
            animation-delay: .3s;
          }

          .qr-loader-bar::after {
            content: "";
            position: absolute;
            inset: 0;
            width: 55%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,.9), transparent);
            animation: qrLoaderBar 1.35s ease-in-out infinite;
          }
        `}</style>

        <div
          style={{
            position: "absolute",
            width: 260,
            height: 260,
            borderRadius: "50%",
            background: "rgba(255,138,0,.16)",
            filter: "blur(40px)",
            top: "18%",
            left: "50%",
            transform: "translateX(-50%)"
          }}
        />

        <div
          className="qr-loader-card"
          style={{
            width: "100%",
            maxWidth: 390,
            background: "rgba(255,255,255,.10)",
            border: "1px solid rgba(255,255,255,.18)",
            backdropFilter: "blur(18px)",
            borderRadius: 34,
            padding: "34px 24px",
            textAlign: "center",
            boxShadow: "0 28px 80px rgba(0,0,0,.38)",
            position: "relative",
            zIndex: 2
          }}
        >
          <div
            style={{
              width: 104,
              height: 104,
              margin: "0 auto 22px",
              borderRadius: "50%",
              background: "rgba(255,255,255,.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative"
            }}
          >
            <div
              className="qr-loader-ring"
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                border: "4px solid rgba(255,255,255,.18)",
                borderTopColor: "#ff8a00",
                borderRightColor: "#ffb347"
              }}
            />

            <div
              style={{
                width: 68,
                height: 68,
                borderRadius: 22,
                background: "linear-gradient(135deg, #ff9f1c, #ff7a00)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#0b1d2d",
                fontSize: 34,
                fontWeight: 900,
                boxShadow: "0 14px 34px rgba(255,138,0,.38)"
              }}
            >
              🍽️
            </div>
          </div>

          <div
            style={{
              fontSize: 14,
              fontWeight: 800,
              letterSpacing: 1.5,
              textTransform: "uppercase",
              color: "#ffb347",
              marginBottom: 8
            }}
          >
            {displayName}
          </div>

          <h2
            style={{
              margin: 0,
              fontSize: "clamp(24px, 6vw, 32px)",
              fontWeight: 950,
              lineHeight: 1.15
            }}
          >
            Menü yükleniyor
          </h2>

          <p
            style={{
              margin: "10px auto 22px",
              maxWidth: 280,
              fontSize: 14,
              lineHeight: "21px",
              color: "rgba(255,255,255,.72)",
              fontWeight: 600
            }}
          >
            Lezzetler ve kategoriler hazırlanıyor.
          </p>

          <div
            className="qr-loader-bar"
            style={{
              width: "100%",
              height: 8,
              borderRadius: 999,
              background: "rgba(255,255,255,.16)",
              overflow: "hidden",
              position: "relative",
              marginBottom: 18
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 8
            }}
          >
            <span
              className="qr-loader-dot"
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ff8a00",
                display: "block"
              }}
            />
            <span
              className="qr-loader-dot"
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ffb347",
                display: "block"
              }}
            />
            <span
              className="qr-loader-dot"
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ffffff",
                display: "block"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
return (
    <div
      ref={menuTopRef}
      data-theme={activeTheme}
      style={{
        background: pageBackground,
        minHeight: "100vh",
        position: "relative",
        color: sectionTitleColor,
        paddingBottom: 124,
        overflowX: "hidden"
      }}
    >

<style>{`

  @keyframes menuFadeUp {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes cartBackdropIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes cartSheetUp {
    0% {
      opacity: 0;
      transform: translateY(100%) scale(.96);
    }
    60% {
      opacity: 1;
      transform: translateY(-10px) scale(1.01);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes cartItemIn {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes themePanelIn {
    from {
      opacity: 0;
      transform: translateY(-10px) scale(.96);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes themeSelectedPulse {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(255,138,0,.30);
    }
    50% {
      box-shadow: 0 0 0 8px rgba(255,138,0,0);
    }
  }

  .cart-backdrop-pro {
    animation: cartBackdropIn .22s ease both;
  }

  .cart-sheet-pro {
    animation: cartSheetUp .42s cubic-bezier(.2,.9,.2,1) both;
  }

  .cart-item-pro {
    animation: cartItemIn .28s ease both;
  }

  .theme-panel-pro {
    animation: themePanelIn .25s cubic-bezier(.2,.9,.2,1) both;
  }

  .theme-option-pro {
    transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  }

  .theme-option-pro:active {
    transform: scale(.98);
  }

  @media (hover: hover) {
    .theme-option-pro:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 26px rgba(15,23,42,.16) !important;
    }
  }

   .theme-selected-dot {
    animation: themeSelectedPulse 1.5s ease infinite;
  }

  @keyframes heroLogoFloat {
    0%, 100% {
      transform: translateY(0) scale(1);
    }
    50% {
      transform: translateY(-5px) scale(1.03);
    }
  }

  @keyframes heroTitleGlow {
    0%, 100% {
      text-shadow: 0 4px 18px rgba(0,0,0,.35);
    }
    50% {
      text-shadow: 0 6px 26px rgba(255,138,0,.30);
    }
  }

  .hero-logo-pro {
    animation: heroLogoFloat 2.4s ease-in-out infinite;
  }

  .hero-title-pro {
    animation: heroTitleGlow 2.8s ease-in-out infinite;
  }

  @media (hover: hover) {
    .menu-category-card-pro:hover {
      transform: translateY(-4px);
      box-shadow: 0 18px 38px rgba(0,0,0,.32) !important;
    }
  }

  @keyframes noticeCenterPop {
    0% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(.72);
    }
    55% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1.08);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes noticeBackdropFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes noticeIconPulse {
    0% {
      transform: scale(.86);
      box-shadow: 0 0 0 0 rgba(34,197,94,.38);
    }
    70% {
      transform: scale(1.04);
      box-shadow: 0 0 0 18px rgba(34,197,94,0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(34,197,94,0);
    }
  }

  .notice-center-backdrop {
    animation: noticeBackdropFade .18s ease both;
  }

  .notice-center-card {
    animation: noticeCenterPop .38s cubic-bezier(.2,.9,.2,1) both;
  }

  .notice-center-icon {
    animation: noticeIconPulse 1.15s ease infinite;
  }


.menu-category-card-pro {
  animation: menuFadeUp .38s ease both;
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
}

.menu-category-card-pro:active {
  transform: scale(.985);
}

@keyframes menuProductSlideRight {
  from {
    opacity: 0;
    transform: translateX(26px) scale(.96);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes menuCategoryOpen {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 2000px;
  }
}

.menu-products-open {
  animation: menuCategoryOpen .42s cubic-bezier(.2,.9,.2,1) both;
  overflow: hidden;
}

.menu-product-card {
  animation: menuProductSlideRight .42s cubic-bezier(.2,.9,.2,1) both;
  transition: transform .24s ease, box-shadow .24s ease, border-color .24s ease;
}

  .menu-product-card:active {
    transform: scale(.98);
  }

  @media (hover: hover) {
    .menu-product-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 14px 28px rgba(0,0,0,.14) !important;
    }

    .menu-product-card:hover .menu-product-img img {
      transform: scale(1.04);
    }
  }

  .menu-product-img img {
    transition: transform .45s ease;
  }

  @keyframes waiterModalBackdropIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes waiterModalCardIn {
    0% {
      opacity: 0;
      transform: translateY(24px) scale(.92);
    }
    60% {
      opacity: 1;
      transform: translateY(-6px) scale(1.02);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes waiterBellFloat {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    35% {
      transform: translateY(-4px) rotate(-8deg);
    }
    70% {
      transform: translateY(-2px) rotate(8deg);
    }
  }

  .waiter-modal-backdrop-pro {
    animation: waiterModalBackdropIn .22s ease both;
  }

  .waiter-modal-card-pro {
    animation: waiterModalCardIn .36s cubic-bezier(.2,.9,.2,1) both;
  }

  .waiter-bell-pro {
    animation: waiterBellFloat 1.35s ease-in-out infinite;
  }


  @keyframes waiterToastIn {
    0% {
      opacity: 0;
      transform: translate(-50%, 24px) scale(.94);
    }
    60% {
      opacity: 1;
      transform: translate(-50%, -4px) scale(1.02);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, 0) scale(1);
    }
  }

  @keyframes waiterPulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255,138,0,.45);
    }
    70% {
      transform: scale(1.04);
      box-shadow: 0 0 0 14px rgba(255,138,0,0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255,138,0,0);
    }
  }

  .waiter-toast {
    animation: waiterToastIn .45s cubic-bezier(.2,.9,.2,1) both;
  }

  .waiter-toast-icon {
    animation: waiterPulse 1.4s ease infinite;
  }

  .menu-product-card:hover .menu-product-img img,
  .menu-product-card:active .menu-product-img img {
    transform: scale(1.08);
  }

  .menu-product-card:hover .menu-photo-shine,
  .menu-product-card:active .menu-photo-shine {
    animation: menuShine .9s ease;
  }

  @keyframes menuShine {
    from {
      transform: translateX(-120%);
    }
    to {
      transform: translateX(120%);
    }
  }

`}</style>






{/* ===== PROFESYONEL TEMA SEÇİM BUTONU ===== */}
{menuOptions.theme_options?.length > 1 && (
  <div
    style={{
      position: "fixed",
      top: 16,
      right: 16,
      zIndex: 650
    }}
  >
    <button
      onClick={() => setShowThemePanel(!showThemePanel)}
      style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        border: "1px solid rgba(255,255,255,.65)",
        background:
          "linear-gradient(135deg, rgba(255,255,255,.98), rgba(255,255,255,.82))",
        boxShadow: "0 14px 34px rgba(15,23,42,.28)",
        fontSize: 19,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(14px)",
        color: "#0b1d2d"
      }}
      title="Tema seç"
    >
      🎨
    </button>

    {showThemePanel && (
      <div
        className="theme-panel-pro"
        style={{
          marginTop: 12,
          width: 248,
          maxHeight: "62vh",
          overflowY: "auto",
          background:
            "linear-gradient(180deg, rgba(255,255,255,.98), rgba(248,250,252,.96))",
        borderRadius: 20,
boxShadow: "0 18px 50px rgba(15,23,42,.28)",
padding: 10,
          border: "1px solid rgba(255,255,255,.82)",
          backdropFilter: "blur(18px)"
        }}
      >
        <div
          style={{
            padding: "8px 8px 12px",
            borderBottom: "1px solid #e5e7eb",
            marginBottom: 10
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 900,
              color: "#64748b",
              letterSpacing: .8,
              textTransform: "uppercase"
            }}
          >
            Menü Teması
          </div>

          <div
            style={{
              marginTop: 4,
              fontSize: 15,
              fontWeight: 950,
              color: "#0b1d2d",
              display: "flex",
              alignItems: "center",
              gap: 8
            }}
          >
            <span>{themeStyle?.icon || "🎨"}</span>
            <span>
              {(QR_THEME_STYLES[activeTheme] || QR_THEME_STYLES.standard).name}
            </span>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 9
          }}
        >
          {menuOptions.theme_options.map((themeId) => {
            const itemTheme = QR_THEME_STYLES[themeId] || {
              name: themeId,
              icon: "🎨",
              primary: "#ff8a00",
              dark: "#0b1d2d",
              bg: "#f8fafc",
              text: "#0b1d2d"
            };

            const selected = activeTheme === themeId;

            return (
              <button
                key={themeId}
                className="theme-option-pro"
                onClick={() => {
                  setActiveTheme(themeId);
                  setShowThemePanel(false);
                }}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  borderRadius: 15,
                  border: selected
                    ? `2px solid ${itemTheme.primary}`
                    : "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  background: selected
                    ? `linear-gradient(135deg, ${itemTheme.primary}20, #ffffff)`
                    : "#ffffff",
                  color: "#111827",
                  cursor: "pointer",
                  boxShadow: selected
                    ? "0 12px 26px rgba(15,23,42,.14)"
                    : "0 6px 16px rgba(15,23,42,.07)",
                  textAlign: "left"
                }}
              >
                <span
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 13,
                    background: `linear-gradient(135deg, ${itemTheme.dark}, ${itemTheme.primary})`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 17,
                    color: "#fff",
                    flexShrink: 0,
                    boxShadow: `0 8px 18px ${itemTheme.primary}55`
                  }}
                >
                  {itemTheme.icon}
                </span>

                <span style={{ flex: 1, minWidth: 0 }}>
                  <span
                    style={{
                      display: "block",
                      fontSize: 12,
                      fontWeight: 950,
                      color: "#0b1d2d",
                      lineHeight: "18px"
                    }}
                  >
                    {itemTheme.name}
                  </span>

                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      marginTop: 5
                    }}
                  >
                    <span
                      style={{
                        width: 16,
                        height: 6,
                        borderRadius: 999,
                        background: itemTheme.primary,
                        display: "block"
                      }}
                    />
                    <span
                      style={{
                        width: 16,
                        height: 6,
                        borderRadius: 999,
                        background: itemTheme.dark,
                        display: "block"
                      }}
                    />
                    <span
                      style={{
                        width: 16,
                        height: 6,
                        borderRadius: 999,
                        background: itemTheme.bg,
                        display: "block",
                        border: "1px solid #e5e7eb"
                      }}
                    />
                  </span>
                </span>

                {selected && (
                  <span
                    className="theme-selected-dot"
                    style={{
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: itemTheme.primary,
                      color: itemTheme.dark,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 950,
                      flexShrink: 0
                    }}
                  >
                    ✓
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    )}
  </div>
)}


           {/* ===== PREMIUM ALT SABİT BAR ===== */}
<div
  style={{
    position: "fixed",
    left: 12,
    right: 12,
    bottom: 12,
    zIndex: 600,
    height: 62,
    borderRadius: 24,
    background: "rgba(15,23,42,0.94)",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 18px 45px rgba(0,0,0,0.45)",
    backdropFilter: "blur(16px)",
    display: "grid",
    gridTemplateColumns: `repeat(${
      1 +
      (menuOptions.garson_cagir_active ? 1 : 0) +
      (menuOptions.siparis_active ? 1 : 0)
    }, minmax(0, 1fr))`,
    overflow: "hidden"
  }}
>
  <button
    type="button"
    onClick={() => {
      setShowCart(false);
      setActiveItem(null);
      setOpenSection(null);

      requestAnimationFrame(() => {
        menuTopRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth"
        });

        document.body.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    }}
    style={{
      border: "none",
      background: "transparent",
      color: "#fff",
      fontWeight: 900,
      fontSize: 12,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 3,
      cursor: "pointer"
    }}
  >
    <span style={{ fontSize: 22 }}>🍽️</span>
    Menü
  </button>

  {menuOptions.garson_cagir_active && (
    <button
      type="button"
      onClick={() => setShowWaiterModal(true)}
      style={{
        border: "none",
        background: "transparent",
        color: "#fff",
        fontWeight: 900,
        fontSize: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        cursor: "pointer"
      }}
    >
      <span style={{ fontSize: 22 }}>🔔</span>
      Garson
    </button>
  )}

  {menuOptions.siparis_active && (
    <button
      type="button"
      onClick={() => setShowCart(true)}
      style={{
        border: "none",
        background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
        color: themeStyle.dark || "#0b1d2d",
        fontWeight: 950,
        fontSize: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        position: "relative",
        cursor: "pointer"
      }}
    >
      <span style={{ fontSize: 23 }}>🛒</span>
      Sepet

      {cart.length > 0 && (
        <span
          style={{
            position: "absolute",
            top: 7,
            right: "24%",
            minWidth: 19,
            height: 19,
            borderRadius: 999,
            background: "#fff",
            color: "#0b1d2d",
            fontSize: 11,
            fontWeight: 950,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 5px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.25)"
          }}
        >
          {cart.reduce((s, i) => s + Number(i.quantity || 0), 0)}
        </span>
      )}
    </button>
  )}
</div>



           {/* ===== PROFESYONEL SİSTEM BİLDİRİMİ ===== */}
      {appNotice && appNotice.position === "center" && (
        <div
          className="notice-center-backdrop"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 700,
            background: "rgba(15,23,42,.28)",
            backdropFilter: "blur(3px)",
            pointerEvents: "none"
          }}
        >
          <div
            className="notice-center-card"
            style={{
              position: "fixed",
              left: "50%",
              top: "50%",
              width: "calc(100% - 44px)",
              maxWidth: 360,
              background: "rgba(255,255,255,.97)",
              borderRadius: 30,
              padding: "28px 22px",
              textAlign: "center",
              boxShadow: "0 26px 70px rgba(15,23,42,.35)",
              border: "1px solid rgba(255,255,255,.8)"
            }}
          >
            <div
              className="notice-center-icon"
              style={{
                width: 86,
                height: 86,
                borderRadius: "50%",
                margin: "0 auto 16px",
                background:
                  appNotice.type === "success"
                    ? "linear-gradient(135deg, #22c55e, #16a34a)"
                    : appNotice.type === "warning"
                    ? "linear-gradient(135deg, #facc15, #f59e0b)"
                    : "linear-gradient(135deg, #ef4444, #dc2626)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: appNotice.icon === "✓" ? 48 : 38,
                fontWeight: 900
              }}
            >
              {appNotice.icon || (
                appNotice.type === "success"
                  ? "✓"
                  : appNotice.type === "warning"
                  ? "ℹ️"
                  : "!"
              )}
            </div>

            <div
              style={{
                fontSize: 21,
                fontWeight: 950,
                color: "#0b1d2d",
                marginBottom: 8
              }}
            >
              {appNotice.title}
            </div>

            <div
              style={{
                fontSize: 14,
                lineHeight: "21px",
                color: "#64748b",
                fontWeight: 700
              }}
            >
              {appNotice.text}
            </div>
          </div>
        </div>
      )}

      {appNotice && appNotice.position !== "center" && (
        <div
          className="waiter-toast"
          style={{
            position: "fixed",
            left: "50%",
            bottom: 96,
            zIndex: 500,
            width: "calc(100% - 32px)",
            maxWidth: 430,
            background: "rgba(255,255,255,.96)",
            backdropFilter: "blur(14px)",
            borderRadius: 24,
            padding: "14px 16px",
            boxShadow: "0 18px 45px rgba(15,23,42,.22)",
            border: "1px solid rgba(255,255,255,.75)",
            display: "flex",
            alignItems: "center",
            gap: 14
          }}
        >
          <div
            className="waiter-toast-icon"
            style={{
              width: 54,
              height: 54,
              borderRadius: "50%",
              background:
                appNotice.type === "success"
                  ? "linear-gradient(135deg, #ff9f1c, #ff7a00)"
                  : appNotice.type === "warning"
                  ? "linear-gradient(135deg, #facc15, #f59e0b)"
                  : "linear-gradient(135deg, #ef4444, #dc2626)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 26,
              flexShrink: 0
            }}
          >
            {appNotice.icon || (
              appNotice.type === "success"
                ? "✓"
                : appNotice.type === "warning"
                ? "ℹ️"
                : "!"
            )}
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 16,
                fontWeight: 900,
                color: "#0b1d2d",
                marginBottom: 3
              }}
            >
              {appNotice.title}
            </div>

            <div
              style={{
                fontSize: 11,
                lineHeight: "18px",
                color: "#64748b",
                fontWeight: 600
              }}
            >
              {appNotice.text}
            </div>
          </div>
        </div>
      )}

  {/* ===== PROFESYONEL GARSON ÇAĞIRMA MODAL ===== */}
{showWaiterModal && (
  <div
    className="waiter-modal-backdrop-pro"
    onClick={() => setShowWaiterModal(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,.62)",
      backdropFilter: "blur(5px)",
      zIndex: 640,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18
    }}
  >
    <div
      className="waiter-modal-card-pro"
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "100%",
        maxWidth: 340,
        background:
          "linear-gradient(180deg, rgba(255,255,255,.99), rgba(248,250,252,.98))",
        borderRadius: 28,
        padding: 18,
        boxShadow: "0 26px 70px rgba(15,23,42,.35)",
        border: "1px solid rgba(255,255,255,.85)",
        overflow: "hidden",
        position: "relative"
      }}
    >
      <div
        style={{
          position: "absolute",
          width: 150,
          height: 150,
          borderRadius: "50%",
          background: `${themeStyle.primary}24`,
          right: -60,
          top: -70
        }}
      />

      <div
        style={{
          textAlign: "center",
          position: "relative",
          zIndex: 2
        }}
      >
        <div
          className="waiter-bell-pro"
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            margin: "0 auto 12px",
            background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
            color: themeStyle.dark,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 34,
            boxShadow: "0 14px 34px rgba(255,138,0,.32)"
          }}
        >
          🔔
        </div>

        <h2
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 950,
            color: "#0b1d2d"
          }}
        >
          {t("waiterTitle", lang)}
        </h2>

              <p
          style={{
            margin: "7px auto 16px",
            fontSize: 13,
            lineHeight: "19px",
            color: "#334155",
            fontWeight: 750,
            maxWidth: 280
          }}
        >
          Masa numaranızı veya adınızı yazın, ekibimiz kısa sürede yardımcı olsun.
        </p>
      </div>

      <div style={{ position: "relative", zIndex: 2 }}>
        <TextField
          label={t("tableNo", lang)}
          fullWidth
          margin="normal"
          value={waiterMasaNo}
          onChange={(e) => setWaiterMasaNo(e.target.value)}
          type="number"
        />

        <TextField
          label={t("customerName", lang)}
          fullWidth
          margin="normal"
          value={waiterAd}
          onChange={(e) => setWaiterAd(e.target.value)}
        />

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 16
          }}
        >
          <button
            onClick={() => setShowWaiterModal(false)}
            style={{
              flex: 1,
              padding: "11px 12px",
              borderRadius: 999,
              border: "1px solid #cbd5e1",
              background: "#fff",
              color: "#0b1d2d",
              fontWeight: 850,
              cursor: "pointer"
            }}
          >
            {t("cancel", lang)}
          </button>

          <button
            onClick={callWaiter}
            style={{
              flex: 1,
              padding: "11px 12px",
              borderRadius: 999,
              border: "none",
              background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
              color: themeStyle.dark,
              fontWeight: 950,
              cursor: "pointer",
              boxShadow: "0 10px 24px rgba(255,138,0,.28)"
            }}
          >
            {t("call", lang)}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

      {/* ===== HEADER ===== */}
      <header
        style={{
          background:
            `radial-gradient(circle at 50% 0%, ${themeStyle.primary}30, transparent 34%),
             linear-gradient(180deg, ${themeStyle.dark} 0%, #071421 68%, ${themeStyle.primary} 150%)`,
          padding: "26px 16px 22px",
          color: "#fff",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.10)",
          boxShadow: "0 14px 38px rgba(0,0,0,0.28)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 220,
            height: 220,
            borderRadius: "50%",
            background: `${themeStyle.primary}22`,
            filter: "blur(34px)",
            left: "50%",
            top: -120,
            transform: "translateX(-50%)",
            pointerEvents: "none"
          }}
        />

        <div style={{ maxWidth: 760, margin: "0 auto", position: "relative", zIndex: 2 }}>
          <div
            className="hero-logo-pro"
            style={{
              width: 52,
              height: 52,
              borderRadius: 19,
              margin: "0 auto 10px",
              background: "linear-gradient(145deg, rgba(255,255,255,.18), rgba(255,255,255,.06))",
              border: "1px solid rgba(255,255,255,0.22)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 27,
              boxShadow: `0 14px 32px rgba(0,0,0,.30), 0 0 28px ${themeStyle.primary}22`,
              backdropFilter: "blur(12px)"
            }}
          >
            🍽️
          </div>

          <h1
            className="hero-title-pro"
            style={{
              fontSize: "clamp(24px,5vw,34px)",
              fontWeight: 950,
              margin: 0,
              letterSpacing: "-0.8px",
              lineHeight: 1.05
            }}
          >
            {contact.kurum_adi}
          </h1>

          <div
            style={{
              marginTop: 6,
              color: "rgba(255,255,255,0.70)",
              fontWeight: 750,
              fontSize: 13
            }}
          >
            {t("welcome", lang)}
          </div>

          <div
            style={{
              marginTop: 12,
              display: "flex",
              justifyContent: "center",
              gap: 8,
              flexWrap: "wrap"
            }}
          >
            {menuLangs.map(l => (
              <button
                key={l}
                onClick={() => setLang(l)}
                style={{
                  padding: "8px 17px",
                  borderRadius: 999,
                  fontWeight: 950,
                  border: l === lang
                    ? `1px solid ${themeStyle.primary}`
                    : "1px solid rgba(255,255,255,0.24)",
                  background: l === lang
                    ? themeStyle.primary
                    : "rgba(255,255,255,0.09)",
                  color: l === lang ? themeStyle.dark : "#fff",
                  boxShadow: l === lang
                    ? `0 10px 24px ${themeStyle.primary}48`
                    : "none",
                  cursor: "pointer"
                }}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>

          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder={TEXT.search[lang]}
            style={{
              marginTop: 16,
              width: "100%",
              maxWidth: 480,
              padding: "15px 18px",
              borderRadius: 22,
              border: "1px solid rgba(255,255,255,0.20)",
              background: "rgba(255,255,255,0.97)",
              color: "#0b1d2d",
              fontSize: 15,
              fontWeight: 800,
              outline: "none",
              boxShadow: "0 14px 34px rgba(0,0,0,0.24)"
            }}
          />
        </div>
      </header>

{/* ===== TREND SLIDER (AUTO) ===== */}
{trendItems.length > 0 && (
  <section style={{ padding: "20px 12px 6px" }}>


    {/* ===== TREND BAŞLIK ===== */}
    <div
      style={{
        textAlign: "center",
        marginBottom: 8
      }}
    >
      <h2
        style={{
          fontSize: "clamp(22px, 5vw, 28px)",
          fontWeight: 800,
          marginBottom: 6,
          color: sectionTitleColor
        }}
      >
        ⭐ {TEXT.trends[lang]}
      </h2>

      <div
        style={{
          width: 60,
          height: 4,
          margin: "0 auto",
          borderRadius: 4,
          background: themeStyle.primary
        }}
      />
    </div>

    <div
      ref={sliderRef}
      style={{
        display: "flex",
        gap: 16,
        overflowX: "auto",
        scrollBehavior: "smooth",
        paddingBottom: 12
      }}
      onTouchStart={() => clearInterval(autoRef.current)}
    >
      {trendItems.map((item) => {
        const priceOptions = normalizePublicPriceOptions(item.price_options);

        return (
          <div
            key={item.id}
            onClick={() => setActiveItem(item)}
                            style={{
              minWidth: 224,
              background: softCardBg,
              borderRadius: 22,
              cursor: "pointer",
              boxShadow: "0 16px 38px rgba(0,0,0,.32)",
              overflow: "hidden",
              border: "1px solid rgba(255,255,255,0.28)"
            }}
          >
            <div
              style={{
                overflow: "hidden",
                borderTopLeftRadius: 18,
                borderTopRightRadius: 18
              }}
            >
              <img
                src={item.image || `${IMAGE_BASE}/default.jpg`}
                alt={item.title}
                style={{
                  width: "100%",
                  height: 148,
                  objectFit: "cover",
                  objectPosition: "center",
                  display: "block"
                }}
                onError={(e) => {
                  e.currentTarget.src = `${IMAGE_BASE}/default.jpg`;
                }}
              />
            </div>

                  <div style={{ padding: 12 }}>
              <strong
                style={{
                  display: "block",
                  color: "#0b1d2d",
                  fontSize: 15,
                  fontWeight: 950,
                  lineHeight: "19px",
                  minHeight: 38,
                  overflow: "hidden"
                }}
              >
                {item.title}
              </strong>

              <div
                style={{
                  color: themeStyle.primary,
                  fontWeight: 950,
                  fontSize: 16,
                  marginTop: 6
                }}
              >
                {getPublicTrendPriceText(item)}
              </div>


            {menuOptions.siparis_active && (
  priceOptions.length > 1 ? (
    <button
      onClick={(e) => {
        e.stopPropagation();
        setActiveItem(item);
      }}
      style={{
        marginTop: 10,
        background: themeStyle.dark,
        color: "#fff",
        border: "none",
        borderRadius: 30,
        padding: "8px 12px",
        fontSize: 12,
        fontWeight: 900,
        cursor: "pointer",
        width: "100%",
        boxShadow: "0 8px 18px rgba(15,23,42,.18)"
      }}
    >
      Seçenekleri Gör
    </button>
  ) : (
    <button
      onClick={(e) => {
        e.stopPropagation();
        addToCart(item);
      }}
      style={{
        marginTop: 10,
        background: themeStyle.dark,
        color: "#fff",
        border: "none",
        borderRadius: 30,
        padding: "8px 12px",
        fontSize: 12,
        fontWeight: 900,
        cursor: "pointer",
        width: "100%"
      }}
    >
      {TEXT.addToCart[lang]}
    </button>
  )
)}





            </div>
          </div>
        );
      })}
    </div>
  </section>
)}

{/* ===== KATEGORİ GEÇİŞ BAŞLIĞI ===== */}
<section
  style={{
    marginTop: 6,
    marginBottom: 4,
    padding: "10px 16px 8px",
    textAlign: "center",
    background: "transparent"
  }}
>
  <h2
    style={{
      fontSize: "clamp(20px, 4vw, 25px)",
      fontWeight: 950,
      margin: 0,
      color: sectionTitleColor,
      letterSpacing: "-0.4px"
    }}
  >
    {TEXT.categories[lang]}
  </h2>

  <div
    style={{
      fontSize: 12,
      color: sectionSubColor,
      marginTop: 4,
      marginBottom: 8,
      fontWeight: 650
    }}
  >
    {TEXT.categoriesSub[lang]}
  </div>

  <div
    style={{
      width: 60,
      height: 4,
      margin: "0 auto",
      borderRadius: 4,
      background: themeStyle.primary,
      boxShadow: `0 6px 16px ${themeStyle.primary}66`
    }}
  />
</section>



{/* ===== KATEGORİLER (PREMIUM KOMPAKT GÖRSELLİ) ===== */}
<div
  style={{
    maxWidth: 1200,
    margin: "0 auto",
    padding: "12px 11px 28px",
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 12,
    alignItems: "start"
  }}
>

  {filteredSections.map(sec =>
    sec.categories.map(cat => {
      const isOpen = openSection === cat.id;

      return (
       

        <div
          key={cat.id}
          ref={(el) => {
            categoryRefs.current[cat.id] = el;
          }}
        className="menu-category-card-pro"
style={{
  gridColumn: isOpen ? "1 / -1" : "auto",
  marginBottom: 0,
  borderRadius: 16,
  overflow: "hidden",
  background: isOpen ? "rgba(255,255,255,0.96)" : softPanelBg,
  boxShadow: isOpen
    ? "0 20px 48px rgba(0,0,0,.34)"
    : "0 12px 28px rgba(0,0,0,.26)",
  border: isOpen ? "1px solid rgba(255,255,255,0.38)" : `1px solid ${softPanelBorder}`,
  scrollMarginTop: 12
}}
        >


          {/* === KATEGORİ KARTI === */}
          <div
                       onClick={() => {
              const nextId = isOpen ? null : cat.id;

              setOpenSection(nextId);

              if (nextId) {
                setTimeout(() => {
                  categoryRefs.current[nextId]?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                }, 100);
              }
            }}
                         style={{
              position: "relative",
              height: isOpen ? 150 : 124,
              cursor: "pointer",
              overflow: "hidden"
            }}
          >
<div style={{ 
  position: "absolute", 
  inset: 0,
  overflow: "hidden"  // 🔥 TAŞMAYI KESER
}}>
  <img
    src={resolveCategoryImage(cat, sec)}
    onError={e => (e.currentTarget.src = `${IMAGE_BASE}/default.jpg`)}
    alt={cat.title}
       style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      filter: "brightness(.82) saturate(1.12) contrast(1.04)",
      display: "block",
      transform: "scale(1.01)"
    }}
  />
</div>

<div
  className="category-title-pro"
  style={{
    position: "absolute",
    left: 8,
    right: 8,
    bottom: 8,
    color: "#fff",
    fontSize: 14,
    fontWeight: 950,
    lineHeight: "17px",
    padding: "8px 10px",
    borderRadius: 13,
    background: "linear-gradient(90deg, rgba(0,0,0,.74), rgba(0,0,0,.32))",
    backdropFilter: "blur(6px)",
    textShadow: "0 2px 8px rgba(0,0,0,.60)",
    boxShadow: "0 8px 20px rgba(0,0,0,.22)"
  }}
>
  {cat.title}
</div>
          </div>

          {/* === ALT ÜRÜNLER === */}
          {isOpen && (
            <div
           style={{
  padding: 12,
  display: "flex",
  flexDirection: "column",
  gap: 10
}}
            >
         
{cat.items.map((item, index) => (
  <div
    key={item.id}
    className="menu-product-card"
    onClick={() => setActiveItem(item)}
style={{
  background: "#ffffff",
  borderRadius: 20,
  overflow: "hidden",
  cursor: "pointer",
  boxShadow: "0 10px 24px rgba(15,23,42,.08)",
  border: "1px solid #e5e7eb",
  display: "grid",
gridTemplateColumns: "112px minmax(0, 1fr)",
  gap: 12,
  padding: 12,
  alignItems: "stretch",
  direction: "ltr",
animationDelay: `${index * 55}ms`
}}
  >
    <div
     style={{
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gridColumn: "2",
  gridRow: "1"
}}
    >
      <strong
        style={{
          fontSize: 14,
          lineHeight: "18px",
          minHeight: 0,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden"
        }}
      >
        {item.title}
      </strong>

      <div
      style={{
  color: "#0f172a",
  fontWeight: 900,
  marginTop: 4,
  fontSize: 14
}}
      >
        {getPublicItemPriceText(item)}
      </div>

      {hasPublicPriceOptions(item) && (
        <div
          style={{
            marginTop: 8,
            padding: "8px 0",
            borderTop: "1px solid #f1f5f9",
            borderBottom: "1px solid #f1f5f9"
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 950,
              color: "#94a3b8",
              letterSpacing: .4,
              textTransform: "uppercase",
              marginBottom: 5
            }}
          >
            Seçenekler
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 4 }}>
            {normalizePublicPriceOptions(item.price_options).slice(0, 5).map((opt) => (
              <div
                key={opt.id}
                style={{
                  minWidth: 0,
                  display: "grid",
                  gridTemplateColumns: "8px minmax(0, 1fr)",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 11,
                  lineHeight: "14px",
                  fontWeight: 800,
                  color: "#334155"
                }}
              >
                <span
                  style={{
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
background: "#94a3b8",
                    display: "block"
                  }}
                />
                <span
                  style={{
                    minWidth: 0,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {opt.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        style={{
          fontSize: 12,
          color: "#555",
          marginTop: 6,
          lineHeight: "16px",
          minHeight: 0,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden"
        }}
      >
        {item.description || ""}
      </div>

      <PublicComplianceBox
        item={item}
        lang={lang}
        themeStyle={themeStyle}
        compact
      />

      {menuOptions.siparis_active && !hasPublicPriceOptions(item) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            addToCart(item);
          }}
          style={{
            marginTop: "auto",
            background: "linear-gradient(135deg, #ff9f1c 0%, #ff7a00 100%)",
            border: "none",
            borderRadius: 999,
            padding: "9px 10px",
            fontWeight: 800,
            cursor: "pointer",
            width: "100%",
            color: "#0b1d2d",
            fontSize: 13,
            boxShadow: "0 6px 14px rgba(255,138,0,.28)"
          }}
        >
          {TEXT.addToCart[lang]}
        </button>
      )}
    </div>

    <div
      className="menu-product-img"
    style={{
  width: 112,
  height: 112,
  borderRadius: 18,
  overflow: "hidden",
  background: "#f8fafc",
  alignSelf: "center",
justifySelf: "start",  gridColumn: "1",
  gridRow: "1",
  boxShadow: "inset 0 0 0 1px #edf2f7"
}}
    >
      <img
        src={item.image || `${IMAGE_BASE}/default.jpg`}
        alt={item.title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          display: "block"
        }}
        onError={(e) => {
          e.currentTarget.src = `${IMAGE_BASE}/default.jpg`;
        }}
      />
    </div>
  </div>
))}




            </div>
          )}
        </div>
      );
    })
  )}
</div>

{/* ⭐ GOOGLE YORUM */}
{googleReview?.google_review_active &&
 googleReview?.google_review_url && (

<section
style={{
padding:"20px 14px",
maxWidth:420,
margin:"10px auto 24px",
}}
>

<div
style={{
background:"rgba(255,255,255,0.94)",
borderRadius:24,
padding:24,
textAlign:"center",
boxShadow:"0 18px 45px rgba(0,0,0,.34)",
border:"1px solid rgba(255,255,255,0.45)",
backdropFilter:"blur(14px)"
}}
>

<div style={{fontSize:36}}>
⭐
</div>

<h2
style={{
color:"#0b1d2d",
fontWeight:800
}}
>
{
googleReview.google_review_title_json?.[lang] ||
"Review us on Google"
}
</h2>


<p
style={{
color:"#666",
fontSize:15
}}
>
{
googleReview.google_review_desc_json?.[lang] ||
"Share your experience"
}
</p>


<a
href={googleReview.google_review_url}
target="_blank"
rel="noreferrer"
style={{
display:"inline-block",
marginTop:12,
background:"#ff8a00",
color:"#0b1d2d",
padding:"12px 24px",
borderRadius:999,
fontWeight:800,
textDecoration:"none"
}}
>

{lang==="de"
?"Auf Google bewerten"
:lang==="en"
?"Review on Google"
:"Google’da Yorum Yap"}

</a>

</div>

</section>

)}

         {/* FOOTER */}
     <footer
  style={{
    background: "rgba(2,6,23,0.72)",
    padding: "34px 16px 34px",
    color: "#fff",
    borderTop: "1px solid rgba(255,255,255,0.08)"
  }}
>
  {/* TURUNCU KART */}
  <div
    style={{
       background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
      borderRadius: 22,
      padding: "22px 20px",
      maxWidth: 420,
      margin: "0 auto 28px",
      color: themeStyle.dark || "#0b1d2d",
      boxShadow: "0 16px 38px rgba(0,0,0,.38)",
      textAlign: "center",    
    }}
  >

    <div
      style={{
        fontSize: 20,
        fontWeight: 700,
        marginBottom: 6
      }}
    >
      {TEXT.thanks[lang]}
    </div>

  
    {/* SOSYAL ICONLAR */}
    <div
      style={{
        display: "flex",
        gap: 12,
        justifyContent: "center"
      }}
    >
     {contact.instagram && <MiniIcon href={contact.instagram} type="instagram" />}
{contact.youtube && <MiniIcon href={contact.youtube} type="youtube" />}
{contact.facebook && <MiniIcon href={contact.facebook} type="facebook" />}
{contact.website && <MiniIcon href={contact.website} type="web" />}
    </div>
  </div>

{/* ALT BİLGİ - FİRMA BAZLI İLETİŞİM */}
<div
  style={{
    textAlign: "center",
    fontSize: 14,
    color: "#c7d0d9",
    lineHeight: "24px",
    maxWidth: 520,
    margin: "0 auto"
  }}
>
{(contact.adres || contact.adres_tr || contact.address) && (
  <div style={{ whiteSpace: "pre-line", marginBottom: 6 }}>
    📍 {contact.adres || contact.adres_tr || contact.address}
  </div>
)}

{(contact.saat || contact.saat_tr || contact.calisma_saati) && (
  <div style={{ whiteSpace: "pre-line", marginBottom: 6 }}>
    🕒 {contact.saat || contact.saat_tr || contact.calisma_saati}
  </div>
)}


{contact.telefon && (
  <div style={{ marginBottom: 6 }}>
    📞 <a
      href={`tel:${contact.telefon}`}
      style={{ color: "#c7d0d9", textDecoration: "none" }}
    >
      {contact.telefon}
    </a>
  </div>
)}
  {contact.whatsapp && (
    <div style={{ marginBottom: 6 }}>
      💬 <a
        href={`https://wa.me/${contact.whatsapp.replace(/\D/g, "")}`}
        target="_blank"
        rel="noreferrer"
        style={{ color: "#c7d0d9", textDecoration: "none" }}
      >
        WhatsApp
      </a>
    </div>
  )}

  {contact.harita_url && (
    <div style={{ marginTop: 10 }}>
      <a
        href={contact.harita_url}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-block",
          padding: "8px 16px",
          borderRadius: 999,
        background: themeStyle.primary,
color: themeStyle.dark,
          fontWeight: 800,
          textDecoration: "none"
        }}
      >
        Konuma Git
      </a>
    </div>
  )}
</div>

    </footer>

      {/* ===== MODAL ===== */}
      {activeItem && (
        <div
          onClick={() => setActiveItem(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 20,
              maxWidth: 420,
              width: "90%",
              overflow: "hidden"
            }}
          >

<ProductImageBox
  src={activeItem.image}
  alt={activeItem.title}
  height={280}
/>

<div style={{ padding: 16 }}>
              <h2>{activeItem.title}</h2>
           <div style={{ color: "#ff8a00", fontWeight: 900, fontSize: 18 }}>
  {getPublicItemPriceText(activeItem)}
</div>

{hasPublicPriceOptions(activeItem) && (
  <div
    style={{
      display: "grid",
      gap: 8,
      marginTop: 12,
      marginBottom: 12
    }}
  >
    {normalizePublicPriceOptions(activeItem.price_options).map((opt) => (
      <button
        key={opt.id}
        onClick={() => {
          addToCart(activeItem, opt);
          setActiveItem(null);
        }}
        style={{
          background: "linear-gradient(135deg, #ff9f1c 0%, #ff7a00 100%)",
          border: "none",
          borderRadius: 18,
          padding: "12px 14px",
          fontWeight: 950,
          cursor: "pointer",
          width: "100%",
          color: "#0b1d2d",
          fontSize: 14,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          boxShadow: "0 8px 18px rgba(255,138,0,.25)"
        }}
      >
        <span>{opt.label}</span>
        <span>{moneyText(opt.price, opt.currency)}</span>
      </button>
    ))}
  </div>
)}

{activeItem.description && (
  <p
    style={{
      color: "#475569",
      lineHeight: "20px",
      fontSize: 14,
      marginTop: 10,
      marginBottom: 0,
    }}
  >
    {activeItem.description}
  </p>
)}

<PublicComplianceBox
  item={activeItem}
  lang={lang}
  themeStyle={themeStyle}
/>

              {/* ✅ EKLENDI: Modal içine de sepete ekle butonu */}


{menuOptions.siparis_active &&
  !hasPublicPriceOptions(activeItem) && (
    <button
      onClick={() => {
        addToCart(activeItem);
        setActiveItem(null);
      }}
      style={{
        marginTop: 10,
        background: "#1565C0",
        border: "none",
        borderRadius: 30,
        padding: "10px 20px",
        fontWeight: 600,
        cursor: "pointer",
        width: "100%",
        color: "#fff"
      }}
    >
      {TEXT.addToCart[lang]}
    </button>
)}
            </div>
          </div>
        </div>
      )}

             {/* ===== PROFESYONEL SEPET DRAWER ===== */}
{menuOptions.siparis_active && showCart && (
  <div
    className="cart-backdrop-pro"
    onClick={() => setShowCart(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,.62)",
      backdropFilter: "blur(5px)",
      zIndex: 620,
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      padding: "0 10px"
    }}
  >
    <div
      className="cart-sheet-pro"
      onClick={(e) => e.stopPropagation()}
      style={{
        background:
          "linear-gradient(180deg, rgba(255,255,255,.99), rgba(248,250,252,.99))",
        width: "100%",
      maxWidth: 460,
borderTopLeftRadius: 26,
borderTopRightRadius: 26,
padding: "12px 12px 16px",
maxHeight: "78vh",
        overflowY: "auto",
        boxShadow: "0 -24px 70px rgba(15,23,42,.38)",
        border: "1px solid rgba(255,255,255,.85)"
      }}
    >
      <div
        style={{
          width: 54,
          height: 5,
          borderRadius: 999,
          background: "#cbd5e1",
          margin: "0 auto 16px"
        }}
      />

      <div
        style={{
          background: `linear-gradient(135deg, ${themeStyle.dark}, ${themeStyle.primary})`,
          borderRadius: 20,
          padding: "12px 13px",
          color: "#fff",
          marginBottom: 12,
          boxShadow: "0 14px 34px rgba(15,23,42,.22)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 150,
            height: 150,
            borderRadius: "50%",
            background: "rgba(255,255,255,.12)",
            right: -50,
            top: -60
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            zIndex: 2
          }}
        >
          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                opacity: .82,
                letterSpacing: .7,
                textTransform: "uppercase"
              }}
            >
              Sipariş Özeti
            </div>

            <h2
              style={{
                margin: "4px 0 0",
                fontSize: 20,
                fontWeight: 950
              }}
            >
              🛒 {t("cart", lang)}
            </h2>
          </div>

          <button
            onClick={() => setShowCart(false)}
            style={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,.35)",
              background: "rgba(255,255,255,.16)",
              color: "#fff",
              fontSize: 18,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            ✕
          </button>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 14,
            position: "relative",
            zIndex: 2
          }}
        >
          <div
            style={{
              flex: 1,
              background: "rgba(255,255,255,.16)",
              border: "1px solid rgba(255,255,255,.20)",
              borderRadius: 14,
              padding: "7px 9px"
            }}
          >
            <div style={{ fontSize: 12, opacity: .78, fontWeight: 700 }}>
              Ürün
            </div>
            <div style={{ fontSize: 15, fontWeight: 950 }}>
              {cart.reduce((s, i) => s + i.quantity, 0)}
            </div>
          </div>

          <div
            style={{
              flex: 1,
              background: "rgba(255,255,255,.16)",
              border: "1px solid rgba(255,255,255,.20)",
              borderRadius: 18,
              padding: "10px 12px"
            }}
          >
            <div style={{ fontSize: 12, opacity: .78, fontWeight: 700 }}>
              {t("total", lang)}
            </div>
            <div style={{ fontSize: 18, fontWeight: 950 }}>
              {cartTotal.toFixed(2)} {cart[0]?.currency || "TL"}
            </div>
          </div>
        </div>
      </div>

      {cart.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "34px 18px",
            background: "#fff",
            borderRadius: 17,
            border: "1px dashed #cbd5e1"
          }}
        >
          <div style={{ fontSize: 44, marginBottom: 10 }}>🛒</div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 950,
              color: "#0b1d2d",
              marginBottom: 6
            }}
          >
            {t("emptyCart", lang)}
          </div>
          <div
            style={{
              fontSize: 11,
              color: "#64748b",
              fontWeight: 650
            }}
          >
            Beğendiğiniz ürünleri sepete ekleyerek sipariş oluşturabilirsiniz.
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              display: "grid",
              gap: 10,
              marginBottom: 16
            }}
          >
            {cart.map((item, index) => (
  <div
    key={item.id}
                className="cart-item-pro"
                style={{
                  animationDelay: `${index * 45}ms`,
                  background: "#fff",
                  borderRadius: 20,
                  padding: 12,
                  border: "1px solid #edf0f4",
                  boxShadow: "0 8px 22px rgba(15,23,42,.08)",
                  display: "grid",
                  gridTemplateColumns: "1fr auto",
                  gap: 10,
                  alignItems: "center"
                }}
              >
                <div style={{ minWidth: 0 }}>
                  <strong
                    style={{
                      display: "block",
                      fontSize: 12,
                      color: "#0b1d2d",
                      lineHeight: "19px",
                      fontWeight: 950
                    }}
                  >
                    {item.title}
                  </strong>

                  <small
                    style={{
                      display: "block",
                      marginTop: 4,
                      color: "#64748b",
                      fontWeight: 700
                    }}
                  >
                    {item.price} {item.currency} × {item.quantity}
                  </small>

                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{
                      marginTop: 8,
                      border: "none",
                      background: "#fee2e2",
                      color: "#b91c1c",
                      borderRadius: 999,
                      padding: "5px 10px",
                      fontSize: 12,
                      fontWeight: 850,
                      cursor: "pointer"
                    }}
                  >
                    Sil
                  </button>
                </div>

<div
  className="menu-products-open"
  style={{
    padding: 12,
    display: "flex",
    flexDirection: "column",
    gap: 10
  }}
>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 950,
                      color: themeStyle.primary,
                      whiteSpace: "nowrap"
                    }}
                  >
                    {(item.price * item.quantity).toFixed(2)} {item.currency}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#f1f5f9",
                      borderRadius: 999,
                      padding: 5
                    }}
                  >
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      style={{
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: 950,
                        color: "#0b1d2d"
                      }}
                    >
                      -
                    </button>

                    <span
                      style={{
                        minWidth: 22,
                        textAlign: "center",
                        fontWeight: 950,
                        color: "#0b1d2d"
                      }}
                    >
                      {item.quantity}
                    </span>

                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      style={{
                        background: themeStyle.primary,
                        border: "none",
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: 950,
                        color: themeStyle.dark
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

                  <div
            style={{
              background: "#f8fafc",
              borderRadius: 24,
              padding: 14,
              border: "1px solid #e2e8f0",
              boxShadow: "0 10px 26px rgba(15,23,42,0.10)",
              color: "#0b1d2d"
            }}
          >
            <TextField
              label={t("customerName", lang)}
              fullWidth
              margin="normal"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />

            <TextField
              label={t("tableNo", lang)}
              fullWidth
              margin="normal"
              value={tableNo}
              onChange={(e) => setTableNo(e.target.value)}
              type="number"
            />

            <TextField
              label={t("orderNote", lang)}
              fullWidth
              margin="normal"
              value={orderNote}
              onChange={(e) => setOrderNote(e.target.value)}
              multiline
              rows={3}
            />

            <div
              style={{
                marginTop: 14,
                padding: "14px 0",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 850,
                  color: "#64748b"
                }}
              >
                {t("total", lang)}
              </span>

              <span
                style={{
                  fontSize: 22,
                  fontWeight: 950,
                  color: "#0b1d2d"
                }}
              >
                {cartTotal.toFixed(2)} {cart[0]?.currency || "TL"}
              </span>
            </div>

            <button
              onClick={submitOrder}
              style={{
                marginTop: 8,
                width: "100%",
                border: "none",
                borderRadius: 999,
                padding: "12px 15px",
                background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
                color: themeStyle.dark,
                fontWeight: 950,
                fontSize: 14,

                cursor: "pointer",
                boxShadow: "0 12px 28px rgba(255,138,0,.28)"
              }}
            >
              {t("orderNow", lang)}
            </button>
          </div>
               </>
      )}
    </div>
  </div>
)}
    </div>
  );
}
